// Bengali language file
export const BN = {
  preparing_zip: "জিপ প্রস্তুত করা হচ্ছে…",
  compressing: "সংকুচিত করা হচ্ছে…",
  info_icon: "একবার সম্পূর্ণ হিসাবে চিহ্নিত হলে, কোনও অতিরিক্ত সদস্য যোগদান করতে বা যোগ করা যাবে না, এবং সমস্ত চ্যাট গ্রুপ নিষ্ক্রিয় করা হবে। অনুগ্রহ করে মনে রাখবেন যে প্রকল্প, সমস্ত চ্যাট গ্রুপ এবং ডেটা সহ, নিষ্ক্রিয় অবস্থায় অ্যাক্সেসযোগ্য থাকবে।",
  mark_is_done: "আপনি কি নিশ্চিত যে আপনি প্রকল্পটিকে সম্পূর্ণ হিসাবে চিহ্নিত করতে চান? একবার চিহ্নিত হলে, কোনও অতিরিক্ত সদস্য যোগদান করতে বা যোগ করা যাবে না, এবং সমস্ত চ্যাট গ্রুপ নিষ্ক্রিয় করা হবে। অনুগ্রহ করে মনে রাখবেন যে প্রকল্প, সমস্ত চ্যাট গ্রুপ এবং ডেটা সহ, নিষ্ক্রিয় অবস্থায় অ্যাক্সেসযোগ্য থাকবে।",
  mark_not_done: "আপনি কি নিশ্চিত যে আপনি প্রকল্পটি আবার খুলতে চান? একবার খোলা হিসাবে চিহ্নিত হলে, অতিরিক্ত সদস্যরা যোগদান করতে বা যোগ করা যাবে, এবং সমস্ত চ্যাট গ্রুপ পুনরায় সক্রিয় করা হবে।",
  mark_as_completed: "প্রকল্পকে সম্পূর্ণ হিসাবে চিহ্নিত করুন",
  room_completed: "প্রকল্প সম্পূর্ণ",
  room_members: "প্রকল্পের সদস্য",
  deactivated_rooms: "নিষ্ক্রিয় প্রকল্প",
  deactivated_chats: "নিষ্ক্রিয় চ্যাট",
  completed_rooms: "সম্পূর্ণ প্রকল্প",
  request_to_join_a_room: 'প্রকল্পে যোগদানের অনুরোধ',
  wants_to_rejoin_room: 'Username প্রকল্প Roomname-এ পুনরায় যোগদান করতে চান।',
  invited_you_to_join_room: 'Username আপনাকে Roomname প্রকল্পে যোগদানের জন্য আমন্ত্রণ জানিয়েছেন।',
  restart: "পুনরায় শুরু করুন",
  update_text: "একটি নতুন আপডেট উপলব্ধ। আপডেট ইনস্টল করতে পুনরায় শুরু ক্লিক করুন।",
  update_availble: "আপডেট উপলব্ধ",
  Loading: "লোড হচ্ছে...",
  logout: "লগআউট",
  back: 'পিছনে',
  company_list: "কোম্পানি তালিকা",
  followers: "অনুসরণকারী",
  followings: "অনুসরণ",
  article: "নিবন্ধ",
  companies: "কোম্পানি",
  one_to_one_chat: " এক-থেকে-এক চ্যাট",
  profile: "প্রোফাইল",
  company: "কোম্পানি",
  company_selection: "কোম্পানি নির্বাচন",
  home: "হোম",
  contact: "যোগাযোগ ",
  add_company: "কোম্পানি যোগ করুন ",
  add_project: "প্রকল্প যোগ করুন ",
  capacities: "ক্ষমতা ",
  work_area: "কাজের এলাকা",
  company_services: "কোম্পানি পরিষেবা",
  website: "ওয়েবসাইট",
  search_contacts: "যোগাযোগ খুঁজুন",
  add_or_join_a_company: "কোম্পানি যোগ করুন বা যোগদান করুন",
  follow: "অনুসরণ করুন",
  following: "অনুসরণ করছেন",
  like: "লাইক",
  company_contacts: "কোম্পানি যোগাযোগ",
  leave_the_company: "কোম্পানি ছেড়ে দিন",
  news: "খবর",
  earlier: "আগে",
  action: "কর্ম",
  another_action: "অন্য কর্ম",
  something_else: "অন্য কিছু",
  search: "খুঁজুন",
  search_rooms: "প্রকল্প খুঁজুন",
  search_articles: "নিবন্ধ খুঁজুন",
  contacts: "যোগাযোগ",
  suggestions: "পরামর্শ",
  project_list: "প্রকল্প তালিকা",
  search_results: "খোঁজার ফলাফল",
  add_or_join_project: "প্রকল্প যোগ করুন বা যোগদান করুন",
  details: "বিস্তারিত",
  your_position_within_company: "অনুগ্রহ করে কোম্পানির মধ্যে আপনার অবস্থান নির্বাচন করুন।",
  close_modal: "বন্ধ করুন",
  map: "মানচিত্র",
  or: "অথবা",
  name: "নাম*",
  street: "রাস্তা*",
  house_number: "বাড়ি নম্বর",
  postal_code: "পোস্টাল কোড",
  city: "শহর*",
  opened_by: "খোলা হয়েছে:",
  project_No: "প্রকল্প-নং: ",
  building_type: "বিল্ডিং টাইপ*",
  building_types: "বিল্ডিং টাইপ",
  add_join: "যোগ করুন/যোগদান করুন",
  mandatory_fiels: "*বাধ্যতামূলক ক্ষেত্র",
  invalid_fiels: "এই ক্ষেত্রটি প্রয়োজনীয়",
  add_or_join_company: "কোম্পানি যোগ করুন বা যোগদান করুন",
  name_of_the_company: "কোম্পানির নাম",
  edit_company_details: "কোম্পানি বিবরণ সম্পাদনা করুন",
  branch_of_the_building_industry: "নির্মাণ শিল্পের শাখা",
  corporate_form: "কর্পোরেট ফর্ম",
  position_within_company: "কোম্পানির মধ্যে অবস্থান",
  request_confirmation: "বিচারাধীন প্রকল্প অনুরোধ",
  company_e_mail: "কোম্পানি ই-মেইল",
  type_of_filter: "ফিল্টার করতে টাইপ করুন...",
  setting: "সেটিং",
  dashboard: "ড্যাশবোর্ড",
  settings: "সেটিংস",
  views: "ভিউ",
  times_seen: "বার দেখা হয়েছে",
  see_more: "...আরও",
  see_less: "...কম",
  in_search: "খোঁজায়",
  reset_password: "পাসওয়ার্ড রিসেট করুন",
  submit: "জমা দিন",
  password: "পাসওয়ার্ড",
  email: "ইমেইল",
  confirm_password: "পাসওয়ার্ড নিশ্চিত করুন",
  reset_email: "ই-মেইল রিসেট করুন",
  update: "আপডেট করুন",
  new_email: "নতুন ই-মেইল",
  kjuup_message: "Kjuup বার্তা",
  delete_profile: "প্রোফাইল মুছুন?",
  my_position: "আমার অবস্থান:",
  add: "যোগ করুন",
  owner_company_admin: "কোম্পানি অ্যাডমিন:",
  owner_company_admin_new: "কোম্পানি অ্যাডমিন",
  mutual_contact: "পারস্পরিক যোগাযোগ",
  mutual_contacts: "পারস্পরিক যোগাযোগ",
  co_owner: "সহ-মালিক",
  managing_director: "ব্যবস্থাপনা পরিচালক",
  associate: "সহযোগী",
  secretary: "সচিব",
  employee: "কর্মচারী",
  project_manage: "প্রকল্প ম্যানেজার",
  auto_chat_translation: "স্বয়ংক্রিয় চ্যাট অনুবাদ",
  translate_room_group_names: "চ্যাট গ্রুপের নাম অনুবাদ করুন",
  translate_room_group_names_info: "চালু থাকলে চ্যাট গ্রুপের নাম স্বয়ংক্রিয়ভাবে ইন্টারফেস ভাষায় অনুবাদ হয়।",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "সক্রিয় থাকলে, অ্যাপ খোলার সময় বার্তার পরিবর্তে ই-মেইল ট্যাব ডিফল্টরূপে খুলবে।",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "ভাষা",
  english: "ইংরেজি",
  german: "জার্মান",
  french: "ফরাসি",
  italian: "ইতালীয়",
  change_language: "ভাষা পরিবর্তন করুন",
  my_companies: "আমার কোম্পানি",
  employees: "কর্মচারী",
  invite_with_a: "Kjuup-এ আমন্ত্রণ করুন",
  add_member: "সদস্য যোগ করুন",
  add_user: "ব্যবহারকারী যোগ করুন",
  send_location: "অবস্থান পাঠান",
  assign_admin_rights: "অ্যাডমিন অধিকার সমন্বয় করুন",
  deactivate_company: "কোম্পানি নিষ্ক্রিয় করুন",
  remove_employees: "কর্মচারী সরান",
  remove_members: "সদস্য সরান",
  no_user_found: "কোনও ব্যবহারকারী পাওয়া যায়নি!",
  approve: "অনুমোদন করুন!",
  deselect_all: "সব নির্বাচন বাতিল করুন",
  select_all: "সব নির্বাচন করুন",
  translation_on_building_projects: "প্রকল্পে অনুবাদ",
  reported_capacities: "রিপোর্ট করা পরিষেবা",
  up_to_50m_exact: "৫০ মিটার পর্যন্ত সঠিক",
  company_details_service: "কোম্পানি পরিষেবা",
  company_contact: "কোম্পানি যোগাযোগ",
  invite_with_link: "Kjuup-এ আমন্ত্রণ করুন",
  share_link: "লিঙ্ক শেয়ার করুন",
  share_company_link: "লিঙ্ক শেয়ার করুন",
  qr_code: "QR কোড",
  copy_link: "লিঙ্ক কপি করুন",
  cancel_link: "লিঙ্ক বাতিল করুন",
  who_has_confirmed_services: "কে আপনার পরিষেবা নিশ্চিত করেছে?",
  projectss: "প্রকল্প",
  add_services: "পরিষেবা যোগ করুন",
  services: "পরিষেবা",
  save_text: "সংরক্ষণ করুন",
  share_on: "শেয়ার করুন:",
  articlen: "নিবন্ধ",
  invite_user_to_confirm_service: "ব্যবহারকারীদের কোম্পানিতে পরিষেবা নিশ্চিত করতে আমন্ত্রণ করুন।",
  link_copied: "লিঙ্ক কপি করা হয়েছে!",
  email_copied: "ইমেইল কপি করা হয়েছে!",
  personal_article: "ব্যক্তিগত নিবন্ধ",
  company_article: "কোম্পানি নিবন্ধ",
  characters_remaining: "অবশিষ্ট অক্ষর",
  optional_information: "ঐচ্ছিক তথ্য",
  project: "প্রকল্প",
  projects: "প্রকল্প...",
  abort: "বাতিল করুন",
  preview: "পূর্বরূপ",
  post: "পোস্ট করুন",
  of: "এর",
  remove: "সরান",
  free_capacity: "চাকরি পোর্টাল",
  current_status_overview: "বর্তমান অবস্থা ওভারভিউ",
  report_capacities: "পরিষেবা রিপোর্ট করুন",
  report_text: "রিপোর্ট",
  search_capacities: "ঠিকাদার খুঁজুন",
  add_project_user: "প্রকল্প ব্যবহারকারী যোগ করুন",
  media: "মিডিয়া",
  links: "লিঙ্ক",
  docs: "ডকুমেন্ট",
  featured_products: "বৈশিষ্ট্যযুক্ত পণ্য...",
  title: "শিরোনাম",
  text: "টেক্সট",
  feed_details: "ফিড বিবরণ",
  add_employee: "কর্মচারী যোগ করুন",
  latest: "সর্বশেষ",
  my_projects: "আমার প্রকল্প",
  cancel: "বাতিল করুন",
  continue: "চালিয়ে যান",
  role_in_the_building_industry: "নির্মাণ শিল্পে ভূমিকা",
  als: "হিসাবে",
  join: "যোগদান করুন",
  find: "খুঁজুন",
  request_to_join_a_company: "কোম্পানিতে যোগদানের অনুরোধ",
  wants_to_join_the_company: "কোম্পানিতে যোগদান করতে চায়",
  filter_by: "দ্বারা ফিল্টার করুন",
  ok: "ঠিক আছে",
  close: "বন্ধ করুন",
  weekly_statistics: "সাপ্তাহিক পরিসংখ্যান",
  is_following_you: "আপনাকে অনুসরণ করছে।",
  as: "হিসাবে",
  has_joined_the: "কোম্পানিতে যোগদান করেছে",
  has_looked_at_your_profile: "আপনার প্রোফাইল দেখেছে।",
  time: "সময়",
  in_searches_in_past_week: "গত সপ্তাহে খোঁজায়।",
  has_liked_your_article: "আপনার নিবন্ধ লাইক করেছে।",
  has_published_a_new_article: "একটি নতুন নিবন্ধ প্রকাশ করেছে।",
  you: "আপনি",
  all_views: "সমস্ত ভিউ",
  all_profile_views: "সমস্ত প্রোফাইল ভিউ",
  mutual_company: "পারস্পরিক কোম্পানি",
  artical_text: "নিবন্ধ লিখুন...",
  you_have_appeared: "আপনি উপস্থিত হয়েছেন",
  your_request_at_the_company: "কোম্পানিতে আপনার অনুরোধ",
  times_you_have_appeared_in_searches: "বার আপনি খোঁজায় উপস্থিত হয়েছেন",
  appear_more_often_in_searches: "খোঁজায় আরও প্রায়ই উপস্থিত হন",
  you_have_been_found: "আপনাকে খুঁজে পাওয়া গেছে",
  improve_profile: "প্রোফাইল উন্নত করুন",
  choose_existing_contact_for_single_chat: "একক চ্যাটের জন্য বিদ্যমান যোগাযোগ চয়ন করুন:",
  in_order_to_add_new_contacts: "নতুন যোগাযোগ যোগ করতে, অনুগ্রহ করে প্রোফাইল পৃষ্ঠায় নতুন যোগাযোগ খুঁজুন।",
  times_in_searches_in_the_last_week: "গত সপ্তাহে খোঁজায় বার। আপনার প্রোফাইল আপডেট করুন এবং আরও সহজে খুঁজে পাওয়ার জন্য আরও বিবরণ যোগ করুন।",
  has_been_confirmed: "নিশ্চিত করা হয়েছে।",
  have_joined_the: "যোগদান করেছে ",
  building_project: " নির্মাণ প্রকল্প।",
  select_with_which_company_you_want_to_connect_to_the_project: "আপনি যে কোম্পানির প্রতিনিধিত্ব করবেন তা নির্বাচন করুন। এটি অন্যান্য অংশগ্রহণকারীদের কাছে প্রদর্শিত হবে।",
  select_with_which_company_you_want_to_connect_to_the_chat: "আপনি যে কোম্পানির প্রতিনিধিত্ব করবেন তা নির্বাচন করুন। এটি অন্যান্য অংশগ্রহণকারীদের কাছে প্রদর্শিত হবে।",
  select_internal_section: "অনুগ্রহ করে অভ্যন্তরীণ বিভাগ নির্বাচন করুন",
  select_profile_image: "প্রোফাইল ছবি নির্বাচন করুন",
  share_user: "ব্যবহারকারী শেয়ার করুন",
  contact_sender_message: "Kjuup-এর সদস্য নয় এমন ব্যক্তিকে Kjuup-এ আমন্ত্রণ করতে এই লিঙ্কটি শেয়ার করুন। এই লিঙ্কটি একাধিক ব্যক্তি নিবন্ধনের জন্য ব্যবহার করতে পারে।",
  project_sender_message: "Kjuup-এর সদস্য নয় এমন ব্যক্তিকে প্রকল্পের নামে আমন্ত্রণ করতে এই লিঙ্কটি শেয়ার করুন। এই লিঙ্কটি একাধিক ব্যক্তি নিবন্ধন করতে এবং Kjuup-এ প্রকল্পের নামে যোগদান করতে ব্যবহার করতে পারে।",
  company_sender_message: "Kjuup-এর সদস্য নয় এমন ব্যক্তিকে কোম্পানি কোম্পানির নামে আমন্ত্রণ করতে এই লিঙ্কটি শেয়ার করুন। এই লিঙ্কটি একাধিক ব্যক্তি নিবন্ধন করতে এবং Kjuup-এ কোম্পানিতে যোগদান করতে ব্যবহার করতে পারে।",
  contact_receivers_message: "Kjuup-এ যোগদানের আমন্ত্রণ লিঙ্ক। অনুগ্রহ করে kjuup-এ নিবন্ধনের জন্য লিঙ্কে ক্লিক করুন।",
  iphone: "iPhone:",
  iphone_recivers_message: "আপনি যদি Apple App Store-এর মাধ্যমে Kjuup ইনস্টল করছেন, তাহলে সফলভাবে ডাউনলোডের পর নিবন্ধন করতে সক্ষম হওয়ার জন্য আপনাকে এই লিঙ্কে ক্লিক করতে হবে।",
  project_receivers_message: "Kjuup-এ প্রকল্পের নামে যোগদানের আমন্ত্রণ লিঙ্ক। অনুগ্রহ করে Kjuup-এ নিবন্ধন করতে এবং প্রকল্পের নামে যোগদান করতে লিঙ্কে ক্লিক করুন।",
  company_receivers_message: "Kjuup-এ কোম্পানি কোম্পানির নামে আমন্ত্রণ লিঙ্ক। অনুগ্রহ করে Kjuup-এ নিবন্ধন করতে এবং কোম্পানি কোম্পানির নামে যোগদান করতে লিঙ্কে ক্লিক করুন।",
  sign_in: "সাইন ইন করুন",
  enter_your_email_add: "আপনার ইমেইল ঠিকানা লিখুন",
  forgot_password: "পাসওয়ার্ড ভুলে গেছেন",
  dont_have_account: "অ্যাকাউন্ট নেই?",
  register: "নিবন্ধন করুন",
  get_app: "অ্যাপ পান",
  registration: "নিবন্ধন",
  dep_ing: "Dipl.-Ing.",
  dr: "ড.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architect",
  prof: "প্রফেসর",
  first_name: "প্রথম নাম",
  last_name: "শেষ নাম",
  have_an_account: "অ্যাকাউন্ট আছে?",
  when_register_you_agree: "নিবন্ধন করার সময় আপনি আমাদের সাথে সম্মত হন",
  term_of_use: "ব্যবহারের শর্ত",
  to: "এ।",
  in_our: "আমাদের",
  data_policy: "ডেটা নীতি",
  they_find_out: "তারা জানতে পারে,",
  we_provide_store_data: "আমরা কীভাবে তথ্য সংগ্রহ, প্রক্রিয়া এবং সংরক্ষণ করি।",
  leaving_company_text: "আপনি কি সত্যিই কোম্পানি ছেড়ে যেতে চান? কোম্পানি ছেড়ে যাওয়ার সময় আপনি সমস্ত সম্পর্কিত প্রকল্প এবং চ্যাট গ্রুপও ছেড়ে যান। আপনি যেকোনো সময় অন্য কোম্পানির সাথে এই প্রকল্পগুলিতে আবার যোগদান করতে পারেন।",
  delete_profile_text: "আপনি কি সত্যিই আপনার প্রোফাইল মুছতে চান? আপনি যখন আপনার প্রোফাইল মুছবেন, কোম্পানি, প্রকল্প এবং চ্যাটের সাথে সমস্ত সংযোগ সরানো হবে। আপনি যেকোনো সময় একটি নতুন প্রোফাইল তৈরি করতে পারেন।",
  confirm: "নিশ্চিত করুন",
  reject: "প্রত্যাখ্যান",
  requet_to_leave: "ছেড়ে যাওয়ার অনুরোধ",
  choose: "চয়ন করুন",
  your_add_member: "সদস্য যোগ করুন",
  if_you: "যদি আপনি",
  can_not_find: "এখানে আপনার যোগাযোগ খুঁজে পাচ্ছেন না।",
  please_wait: "অনুগ্রহ করে অপেক্ষা করুন..",
  imprint_gtc: "ইমপ্রিন্ট/শর্তাবলী",
  register_confirm_popup: "লগ ইন করার আগে আপনার Kjuup ইমেল যাচাই করুন। আমরা একটি নিশ্চিতকরণ লিঙ্ক পাঠিয়েছি। না দেখলে স্প্যাম ফোল্ডারও দেখুন।",
  PENDING_GROUP_USER: "প্রকল্পে আমন্ত্রণ নিশ্চিত হওয়ার পরেই বার্তা পাবে। প্রকল্পে আমন্ত্রণ নিশ্চিত হওয়ার সাথে সাথে একটি অতিরিক্ত বার্তা প্রদর্শিত হবে।",
  PENDING: "প্রকল্পে আমন্ত্রণের নিশ্চিতকরণ বিচারাধীন",
  denied_group_chat: " প্রকল্পের আমন্ত্রণ প্রত্যাখ্যান করেছে এবং এই গ্রুপ ছেড়ে গেছে।",
  joined_group_chat: " এই গ্রুপে যোগদান করেছে",
  you_joined_group_chat: "আপনি এই গ্রুপে যোগদান করেছেন।",
  Others: "অন্যান্য",
  LEFT_GROUP: "এই চ্যাট গ্রুপ ছেড়ে গেছে।",
  YOU_LEFT_GROUP: "এই চ্যাট গ্রুপ ছেড়ে গেছে।",
  days: "দিন",
  day: "দিন",
  hour: "ঘন্টা",
  hide_project: "প্রকল্প লুকান",
  hide_project_popup_text: "আপনি যদি প্রকল্প লুকান, তাহলে সেগুলি Kjuup-এর মধ্যে খুঁজে পাওয়া যাবে না। শুধুমাত্র প্রকল্পের সদস্যরা নতুন ব্যবহারকারীদের প্রকল্পে আমন্ত্রণ করতে পারে।",
  branch: "শাখা",
  photo_video_media_lib: "ফoto - ভিডিও মিডিয়া লাইব্রেরি",
  document: "ডকুমেন্ট",
  location_meeting: "অবস্থান / মিটিং",
  all_member_of_project: "প্রকল্পের সমস্ত সদস্য",
  pending_request: "বিচারাধীন প্রকল্প অনুরোধ",
  no_pending_request: "কোনও বিচারাধীন অনুরোধ পাওয়া যায়নি!",
  news_feed: "নিউজ-ফিড",
  user_info: "গ্রুপ তথ্য",
  leave_project: "প্রকল্প ছেড়ে দিন",
  media_link_docs: "ফাইল",
  search_chat: "চ্যাট খুঁজুন",
  export_chat_group: "গত মাস থেকে চ্যাট গ্রুপ ডেটা এক্সপোর্ট করুন",
  request_complete_chat_history: "সম্পূর্ণ চ্যাট ইতিহাস অনুরোধ করুন",
  leave_chat_group: "চ্যাট গ্রুপ ছেড়ে দিন",
  add_user_project: "ব্যবহারকারী যোগ করুন",
  me: "আমি",
  max_open_one_to_one: "বর্তমানে সর্বোচ্চ ২টি এক-থেকে-এক চ্যাট নীচে এবং উপরের অংশে সমান্তরালে খোলা যেতে পারে। মোট সর্বোচ্চ ৪টি এক-থেকে-এক চ্যাট সম্ভব।",
  are_you_sure_you_want_leave_chat: "আপনি কি নিশ্চিত যে আপনি এই চ্যাট গ্রুপ ছেড়ে যেতে চান?",
  create_group: "গ্রুপ তৈরি করুন",
  adding_members: "সদস্য যোগ করা হচ্ছে...",
  creating_the_chat: "চ্যাট তৈরি হচ্ছে...",
  finishing_setup: "সেটআপ সম্পন্ন হচ্ছে...",
  group_name: "গ্রুপের নাম",
  by: "দ্বারা:",
  mandetory: "*বাধ্যতামূলক",
  delteed: "তার প্রোফাইল মুছে দিয়েছে এবং গ্রুপ চ্যাট ছেড়ে গেছে।",
  deleted_direct: "তার প্রোফাইল মুছে দিয়েছে এবং চ্যাট ছেড়ে গেছে।",
  unhidden_message: "আপনি যদি প্রকল্পের লুকানো বাতিল করেন, তাহলে Kjuup-এর সমস্ত সদস্য সেগুলি খুঁজে পেতে পারে।",
  account_deleted: "অ্যাকাউন্ট মুছে দেওয়া হয়েছে।",
  refuse_company: "আপনি কি নিশ্চিত যে আপনি কোম্পানির আমন্ত্রণ প্রত্যাখ্যান করতে চান?",
  follow_additional: "অতিরিক্ত ব্যবহারকারী অনুসরণ করুন",
  f_add: "সরাসরি বার্তার জন্য তাদের উপলব্ধ করতে Kjuup-এর অতিরিক্ত ব্যবহারকারীদের অনুসরণ করুন।",
  c_inv: "কোম্পানি আমন্ত্রণ",
  invited_o_Company: "আপনাকে কোম্পানিতে যোগদানের জন্য আমন্ত্রণ করা হয়েছে",
  refuse_companyX: "আপনি কি নিশ্চিত যে আপনি কোম্পানির অনুরোধ প্রত্যাখ্যান করতে চান?",
  a_Da: "অ্যাকাউন্ট নিষ্ক্রিয় করা হয়েছে।",
  has_deactivated: "তার প্রোফাইল নিষ্ক্রিয় করেছে।",
  reactive: "তার প্রোফাইল পুনরায় সক্রিয় করেছে।",
  juup_note: "*ব্যবহারকারীর নাম দিয়ে নিবন্ধন শুধুমাত্র Kjuup+ সদস্যদের জন্য উপলব্ধ",
  username: "ব্যবহারকারীর নাম*",
  email_username: "ইমেইল/ব্যবহারকারীর নাম*",
  sPinText: "অনুগ্রহ করে একটি ৬-অঙ্কের নিরাপত্তা PIN প্রদান করুন। এই PIN আপনার পাসওয়ার্ড ভুলে গেলে প্রয়োজন হবে এবং আপনার অ্যাকাউন্ট নিশ্চিত করার জন্য বাধ্যতামূলক।",
  DeleteKjuupPlusText: "আপনি কি সত্যিই আপনার প্রোফাইল মুছতে চান? আপনি যখন আপনার প্রোফাইল মুছবেন, কোম্পানি, প্রকল্প এবং চ্যাটের সাথে সমস্ত সংযোগ সরানো হবে।\n\nঅ্যাকাউন্ট মুছে দেওয়ার ৪৮ ঘন্টার মধ্যে আপনি ব্যবহারকারীর নাম, পাসওয়ার্ড এবং PIN দিয়ে সাইন ইন করে আপনার অ্যাকাউন্ট পুনরায় সক্রিয় করতে পারেন।",
  reactive_text: "আপনার অ্যাকাউন্ট মুছে দেওয়া হয়েছে। অনুগ্রহ করে আপনার অ্যাকাউন্ট পুনরায় সক্রিয় করতে পুনরায় সক্রিয় করুন ক্লিক করুন।",
  rac: "পুনরায় সক্রিয় করুন",
  ac_ss: "অ্যাকাউন্ট সফলভাবে পুনরায় সক্রিয় করা হয়েছে।",
  not_valid_pin: "PIN অবৈধ",
  only_for_kjuup: "*ব্যবহারকারীর নাম এবং PIN-এর মাধ্যমে পাসওয়ার্ড রিসেট শুধুমাত্র Kjuup+ সদস্যদের জন্য উপলব্ধ।",
  resetPIN: "PIN রিসেট করুন",
  enter_current_pin: "অনুগ্রহ করে আপনার বর্তমান PIN লিখুন",
  enter_new: "নতুন PIN লিখুন",
  pin_to_confirm: "অনুগ্রহ করে নিশ্চিত করার জন্য PIN প্রদান করুন।",
  change_username: "ব্যবহারকারীর নাম রিসেট করুন",
  pp_not_match: "পাসওয়ার্ড - এবং নিশ্চিত পাসওয়ার্ড মেলে না",
  reactive_itself: "আপনি আপনার প্রোফাইল পুনরায় সক্রিয় করেছেন।",
  has_deactivated_itself: "আপনি আপনার প্রোফাইল নিষ্ক্রিয় করেছেন।",
  more_than_two: "বর্তমানে সরাসরি বার্তা শুধুমাত্র ২ জন ব্যবহারকারীর সাথে সমান্তরালে করা যেতে পারে।",
  Chats: "সরাসরি বার্তা",
  only_in_mobileL: "নেটিভ ভিডিও বর্তমানে শুধুমাত্র মোবাইল অ্যাপের মাধ্যমে আপলোড এবং পোস্ট করা যেতে পারে। অনুগ্রহ করে Youtube এবং Vimeo-এর ভিডিও লিঙ্ক ব্যবহার করুন।",
  register_pin_text: "অনুগ্রহ করে আপনার ব্যক্তিগত ৬-অঙ্কের PIN নির্বাচন করুন। এই PIN অ্যাকাউন্ট রিসেট কার্যকারিতা সক্ষম করার জন্য প্রয়োজন হবে।",
  internal_project: "অভ্যন্তরীণ",
  external_projects: "বাহ্যিক",
  in_deacticted: "অভ্যন্তরীণ বিভাগ নিষ্ক্রিয় করা হয়েছে।",
  create_article: "নিবন্ধ তৈরি করুন",
  new_article_selection: "বাহ্যিক নিউজ-ফিডের জন্য নিবন্ধ তৈরি করুন",
  new_article_selection_internal: "অভ্যন্তরীণ নিবন্ধ তৈরি করুন",
  active_trans_title: "স্বয়ংক্রিয় অনুবাদ চালু করবেন?",
  active_trans: "সক্রিয় হলে, সমস্ত আগত চ্যাট বার্তা আপনার নির্বাচিত অ্যাপ ভাষায় অনুবাদ করা হবে।",
  disable_trans: "আপনি কি সত্যিই স্বয়ংক্রিয় অনুবাদ নিষ্ক্রিয় করতে চান?",
  allow_access_chat: "সম্পূর্ণ চ্যাট ইতিহাস দেখান",
  toggle_chat_history_on: "আপনি কি সত্যিই চান যে ব্যবহারকারী সম্পূর্ণ চ্যাট ইতিহাস দেখুক?",
  toggle_chat_history_off: "আপনি কি সত্যিই চান যে ব্যবহারকারী শুধুমাত্র চ্যাটে যোগদানের বিন্দু থেকে চ্যাট ইতিহাস দেখুক?",
  check_selected_settings: "অনুগ্রহ করে নির্বাচিত সমস্ত ব্যবহারকারীর জন্য চ্যাট ইতিহাসের সেটিংস পরীক্ষা করুন!",
  chat_from_start_have: "আপনি এই গ্রুপে যোগদান করেছেন। চ্যাট ইতিহাস শেয়ার করা হয়েছে।",
  chat_from_start_has: "এই গ্রুপে যোগদান করেছে। চ্যাট ইতিহাস শেয়ার করা হয়েছে।",
  Address: "ঠিকানা",
  read_by: "দ্বারা পড়া হয়েছে",
  deliver_to: "প্রেরণ করা হয়েছে",
  remaining: "অবশিষ্ট",
  message_info: "বার্তা তথ্য",
  request_to_join_only: "যোগদানের অনুরোধ",
  unfollow: "অনুসরণ বন্ধ করুন",
  company_username: "ব্যবহারকারীর নাম",
  month: ["জানুয়ারী", "ফেব্রুয়ারী", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্টেম্বর", "অক্টোবর", "নভেম্বর", "ডিসেম্বর"],
  remove_my_admin_right: "আমার অ্যাডমিন অধিকার সরান",
  makeEmp: "আপনি কি সত্যিই ব্যবহারকারী থেকে কোম্পানি অ্যাডমিন অধিকার সরাতে চান?",
  remove_my_self: "আপনি কি সত্যিই আপনার অ্যাকাউন্ট থেকে কোম্পানি অ্যাডমিন অধিকার সরাতে চান?",
  makeAdmin: "আপনি কি সত্যিই ব্যবহারকারীকে কোম্পানি অ্যাডমিন অধিকার দিতে চান?",
  remove_member: "সদস্য সরান",
  remove_following_confirm: "আপনি কি সত্যিই {name} কে অনুসরণের তালিকা থেকে সরাতে চান?",
  remove_follower_confirm: "আপনি কি সত্যিই {name} কে আপনার অনুসরণকারীদের তালিকা থেকে সরাতে চান? সরালে তাকে জানানো হবে না।",
  do_you_really_want_to_remove: "আপনি কি সত্যিই কোম্পানি থেকে ব্যবহারকারীর নাম সরাতে চান?",
  invite_all: "কোম্পানির সমস্ত সদস্য আমন্ত্রণ করুন",
  invite_all_members: "সমস্ত সদস্য আমন্ত্রণ করুন",
  mems: "অন্যান্য সমস্ত সদস্য",
  dep_loc: "বিভাগ/অবস্থান/টিম",
  depAdmin: "বিভাগ অ্যাডমিন",
  add_remove_admin: "কোম্পানি অ্যাডমিন পদ যোগ করুন/সরান",
  add_remove_dep_admin: "বিভাগ অ্যাডমিন পদ যোগ করুন/সরান",
  remove_employees_dept: "থেকে কর্মচারী সরান",
  want_to_join_dep: "ব্যবহারকারীর নাম কোম্পানি companyname-এর বিভাগ/অবস্থান/টিম depname-এ যোগদান করতে চায়।",
  you_invited: "আপনাকে কোম্পানি companyname-এর বিভাগ/অবস্থান/টিম depname-এ যোগদানের জন্য আমন্ত্রণ করা হয়েছে।",
  dep_remove: "আপনি কি সত্যিই ব্যবহারকারী থেকে বিভাগ বা অবস্থানের অ্যাডমিন অধিকার সরাতে চান?",
  add_dep: "আপনি কি সত্যিই ব্যবহারকারীকে বিভাগ বা অবস্থানের অ্যাডমিন অধিকার দিতে চান?",
  my_self_dep_remove: "আপনি কি সত্যিই আপনার অ্যাকাউন্ট থেকে বিভাগ অ্যাডমিন অধিকার সরাতে চান?",
  member: "সদস্য",
  admin: "অ্যাডমিন",
  remove_project_admin: "আপনি কি সত্যিই প্রকল্প থেকে সদস্য সরাতে চান?",
  remove_my_self_project: "আপনি কি সত্যিই অ্যাডমিন অধিকার সরাতে চান?",
  remove_member_admin_right: "আপনি কি সত্যিই ব্যবহারকারী থেকে অ্যাডমিন অধিকার সরাতে চান?",
  add_member_admin_right: "আপনি কি সত্যিই ব্যবহারকারীকে অ্যাডমিন অধিকার যোগ করতে চান?",
  add_remove_Poss: "অ্যাডমিন পদ যোগ করুন/সরান",
  forward: "ফরওয়ার্ড করুন",
  edit: "সম্পাদনা করুন",
  only_kjuup_plus_can: "শুধুমাত্র Kjuup+ কোম্পানি নিবন্ধ পোস্ট করতে পারে।",
  add_images: "ছবি যোগ করুন",
  request_confirmation: 'বিচারাধীন প্রকল্প আমন্ত্রণ',
  Activity: "কার্যক্রম",
  latest_messages: "সর্বশেষ বার্তা",
  hours: "ঘন্টা",
  minute: "মিনিট",
  seconds: "সেকেন্ড",
  days: "দিন",
  yesterday: "গতকাল",
  last_week: "গত সপ্তাহ",
  next_week: "পরবর্তী সপ্তাহ",
  Last_month: "গত মাস",
  All: "সব",
  register_plus: "নিবন্ধন প্লাস",
  select_files: "ফাইল নির্বাচন করুন",
  monthsFullName: ["জানুয়ারী", "ফেব্রুয়ারী", "মার্চ", "এপ্রিল", "মে", "জুন", "জুলাই", "আগস্ট", "সেপ্টেম্বর", "অক্টোবর", "নভেম্বর", "ডিসেম্বর"],
  company_deploc_receivers_message: "Kjuup-এ কোম্পানি company name-এর বিভাগে আমন্ত্রণ লিঙ্ক। অনুগ্রহ করে Kjuup-এ নিবন্ধন করতে এবং কোম্পানি company name-এ যোগদান করতে লিঙ্কে ক্লিক করুন।",
  no_news: "কোনও খবর উপলব্ধ নেই",
  reminder: "রিমাইন্ডার",
  np_reminder: "কোনও ToDo নেই",
  move_to_reminder: "ToDo-তে সরান",
  remove_reminder: "আপনি কি সত্যিই এই বার্তাটি আপনার ToDo-এর তালিকা থেকে সরাতে চান?",
  remove_all_reminder: "সমস্ত ToDo সরান",
  remove_all_confirm: "আপনি কি সত্যিই সমস্ত বার্তা আপনার ToDo-এর তালিকা থেকে সরাতে চান?",
  remove_from_reminder: "রিমাইন্ডার থেকে সরান",
  prevent_email: "ই-মেইল ব্যবহারকারীর নাম হিসাবে ব্যবহার করা যাবে না।",
  allow_noti: "অনুগ্রহ করে বিজ্ঞপ্তি অনুমতি দিন।",
  join_cap: "যোগদান করুন",
  pass_minimum: "**পাসওয়ার্ডের জন্য ১২টি অক্ষর প্রয়োজন যার মধ্যে ছোট হাতের, বড় হাতের, সংখ্যা এবং বিশেষ অক্ষর অন্তর্ভুক্ত।",
  pass_error: "অনুগ্রহ করে পাসওয়ার্ডের প্রয়োজনীয়তা পরীক্ষা করুন",
  people_that_like_article: "যারা নিবন্ধটি পছন্দ করেছে।",
  people_who_like_article: "যারা আপনার নিবন্ধ পছন্দ করেছে।",
  message_delete: "এই বার্তা মুছে দেওয়া হয়েছে।",
  message_edited: "সম্পাদিত",
  edit_message: "বার্তা সম্পাদনা করুন",
  edit_window_expired: "বার্তা পাঠানোর ১০ মিনিটের মধ্যেই সম্পাদনা করা যায়।",
  message_edit_save: "সংরক্ষণ",
  copy: "কপি",
  bookmark: "বুকমার্ক",
  add_reaction: "প্রতিক্রিয়া যোগ করুন",
  delete_message: "বার্তা মুছুন",
  more_options: "আরও অপশন",
  info: "তথ্য",
  link_invite: "লিঙ্কের মাধ্যমে আমন্ত্রণ করুন",
  ll_nkk: "Kjuup-এ আমন্ত্রণ করুন",
  selected: "নির্বাচিত",
  is_active: "সক্রিয়",
  inactive: "নিষ্ক্রিয়",
  last_online: "শেষ দেখা {{when}}",
  remove_user_l: "সরান",
  link_expire: "প্রতিটি তৈরি করা লিঙ্ক ৭২ ঘন্টার জন্য বৈধ হবে।",
  company_language: "কোম্পানির ভাষা",
  company_language_info: "ভাষা নির্বাচন কোম্পানি সম্পর্কিত সমস্ত ইমেইল নিশ্চিতকরণের জন্য ব্যবহার করা হবে।",
  s_image: "ছবি",
  m_image: "ছবি",
  removeMsg: "সরাতে ট্যাপ করুন",
  block: 'ব্লক করুন',
  unblock: 'আনব্লক করুন',
  blocks: 'আপনি কি নিশ্চিত যে আপনি এই ব্যবহারকারীকে ব্লক করতে চান?',
  unblocks: 'আপনি কি নিশ্চিত যে আপনি এই ব্যবহারকারীকে আনব্লক করতে চান?',
  bolcked_click_un_block: 'আপনি এই যোগাযোগ ব্লক করেছেন। ব্লকিং সরাতে এখানে ক্লিক করুন।',
  you_have_unblocked: 'আপনি এই যোগাযোগ আনব্লক করেছেন।',
  you_have_blocked: 'আপনি এই যোগাযোগ ব্লক করেছেন।',
  unblock_to_send: 'বার্তা পাঠাতে ব্যবহারকারী আনব্লক করুন।',
  pilot_text: "নির্মাণ বিষয়ের জন্য বিশেষায়িত AI",
  startup_screen_label: "স্টার্ট স্ক্রিন",
  startup_screen_info: "Kjuup শুরু হলে কোন স্ক্রিন খুলবে তা বেছে নিন।",
  startup_screen_feed: "Home",
  startup_screen_messages: "বার্তা",
  startup_screen_saved: "স্টার্ট স্ক্রিন আপডেট হয়েছে",
email_on: "ইমেইল বিজ্ঞপ্তি চ্যাট",
  email_on_grp: "ইমেইল বিজ্ঞপ্তি",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "এই প্রকল্পের জন্য ইমেইল বিজ্ঞপ্তি সক্রিয় বা নিষ্ক্রিয় করুন। এই বিকল্পটি শুধুমাত্র তখনই উপলব্ধ যখন \"ইমেইল বিজ্ঞপ্তি চ্যাট\" ব্যক্তিগত সেটিংসের মাধ্যমে সক্রিয় করা হয়।",
  todo_notification_info: "যখনই আপনাকে একটি নতুন কাজ বরাদ্দ করা হবে, আপনাকে অবহিত করা হবে।",
  info_val: "নতুন চ্যাট বার্তা অল্প সময়ের মধ্যে না পড়লে আপনি একটি ইমেইল পাবেন। আপনি নির্দিষ্ট প্রকল্প বা চ্যাটের জন্য তাদের সেটিংসে বা চ্যাট গ্রুপ তথ্যে এটি বন্ধ করতে পারেন।",
  email_groups: "এই চ্যাটের জন্য ইমেইল বিজ্ঞপ্তি সক্রিয় বা নিষ্ক্রিয় করুন। এই বিকল্পটি শুধুমাত্র তখনই উপলব্ধ যখন \"ইমেইল বিজ্ঞপ্তি চ্যাট\" ব্যক্তিগত এবং প্রকল্প সেটিংসের মাধ্যমে সক্রিয় করা হয়।",
  add_update_email: "ইমেইল যোগ করুন/আপডেট করুন",
  text_to_verifiy: "\"ইমেইল বিজ্ঞপ্তি চ্যাট\" বিকল্পটি শুধুমাত্র তখনই সক্রিয় করা যেতে পারে যখন আপনার ফাইলে একটি যাচাইকৃত ইমেইল ঠিকানা থাকে।",
  stored_email: "সংরক্ষিত ইমেইল: ",
  verify_email: "নিশ্চিতকরণ বিচারাধীন!",
  join_call: "যোগদান করুন",
  call_is_started: "কল শুরু হয়েছে",
  start_chat: "সরাসরি চ্যাট শুরু করবেন?",
  project_rooms: "প্রকল্প",
  download_selected: "ডাউনলোড করুন",
  add_employee_confirm: 'আপনি কি নিশ্চিত যে আপনি এই ব্যবহারকারীকে কোম্পানিতে যোগ করতে চান?',
  invalid_deeplink: "অবৈধ deeplink URL। প্রয়োজনীয় পরামিতি অনুপস্থিত।",
  deeplink_error: "deeplink প্রক্রিয়া করতে অক্ষম। অনুগ্রহ করে পরে আবার চেষ্টা করুন।",
  reply: "উত্তর দিন",
  reply_enter: "উত্তর লিখুন...",
  reply_sent_successfully: "উত্তর সফলভাবে পাঠানো হয়েছে",
  reply_failed: "উত্তর পাঠাতে ব্যর্থ",
  reply_failed_generic: "উত্তর পাঠাতে ব্যর্থ। অনুগ্রহ করে আবার চেষ্টা করুন।",
  replying_to_message: "বার্তায় উত্তর দিচ্ছেন",
  cancel_reply: "উত্তর বাতিল করুন",
  voice_message: "ভয়েস বার্তা",
  send: "পাঠান",
  cancel: "বাতিল করুন",
  type_your_reply: "আপনার উত্তর টাইপ করুন...",
  suggested_replies: "প্রস্তাবিত উত্তর",
  suggestions_error: "পরামর্শ লোড করতে ব্যর্থ",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "এক মুহূর্ত। আপনার টেক্সট আপনার জন্য ব্যক্তিগতভাবে প্রস্তুত করা হচ্ছে।",
  loading_chat_message: "চ্যাট লোড হচ্ছে...",
  extracting_message: "বার্তা বের করা হচ্ছে...",
  create_todo: "ToDo তৈরি করুন",
  create_todo_confirmation: "আপনি কি এই বার্তা থেকে ToDo তৈরি করতে চান?",
  select_project_required: "অনুগ্রহ করে একটি প্রকল্প/গ্রুপ নির্বাচন করুন",
  only_assigned_can_change_status: "শুধুমাত্র নির্ধারিত ব্যবহারকারীরা অবস্থা পরিবর্তন করতে পারে",
  todo_summary: "সারাংশ",
  todo_summary_placeholder: "todo সারাংশ লিখুন...",
  todo_date: "তারিখ",
  todo_time: "সময়",
  todo_date_hint: "মূল বার্তার তারিখ/সময় ব্যবহার করতে খালি রাখুন",
  todo_created_success: "ToDo সফলভাবে তৈরি করা হয়েছে",
  todo_creation_failed: "ToDo তৈরি করতে ব্যর্থ",
  create: "তৈরি করুন",
  image: "ছবি",
  images: "ছবি",
  remove_all_images: "সমস্ত ছবি সরান",
  remove_image: "ছবি সরান",
  remove_document: "ডকুমেন্ট সরান",
  remove_recording: "রেকর্ডিং সরান",
  play_recording: "রেকর্ডিং চালান",
  upload_image: "ছবি আপলোড করুন",
  upload_document: "ডকুমেন্ট আপলোড করুন",
  record_audio: "অডিও রেকর্ড করুন",
  stop_recording: "রেকর্ডিং বন্ধ করুন",
  stop_recording_text: "রেকর্ডিং বন্ধ করুন",
  please_remove_current_attachment: "অনুগ্রহ করে বর্তমান সংযুক্তি সরান",
  please_upload_image_file: "অনুগ্রহ করে একটি বৈধ ছবি ফাইল আপলোড করুন",
  please_upload_valid_document: "অনুগ্রহ করে একটি বৈধ ডকুমেন্ট ফাইল আপলোড করুন",
  searching_messages: "বার্তা খুঁজছেন...",
  loading_more: "আরও লোড হচ্ছে...",
  loading_more_users: "আরও ব্যবহারকারী লোড হচ্ছে...",
  load_more_users: "আরও ব্যবহারকারী লোড করুন",
  no_more_users_to_load: "লোড করার জন্য আর কোনও ব্যবহারকারী নেই",
  no_messages_found: "কোনও বার্তা পাওয়া যায়নি",
  try_different_keyword: "একটি ভিন্ন কীওয়ার্ড চেষ্টা করুন বা আপনার বানান পরীক্ষা করুন।",
  search_messages: "বার্তা, চ্যাট গ্রুপ, প্রজেক্ট এবং ব্যবহারকারী খুঁজুন...",
  todo: "ToDo",
  np_todo: "কোনও ToDo নেই",
  move_to_todo: "ToDo হিসাবে সংরক্ষণ করুন",
  remove_todo: "আপনি কি সত্যিই ToDo সরাতে চান?",
  remove_all_todo: "সমস্ত ToDo সরান",
  remove_all_todo_confirm: "আপনি কি সত্যিই সমস্ত ToDo সরাতে চান?",
  add_to_todo: "ToDo-তে যোগ করুন",
  remove_from_todo: "ToDo থেকে সরান",
  confirm: "নিশ্চিত করুন",
  ok: "ঠিক আছে",
  read_more: "আরও পড়ুন",
  show_less: "কম দেখান",
  show_more: "আরও দেখান",
  audio: "অডিও",
  video: "ভিডিও",
  notification_schedule: "বিজ্ঞপ্তি সময়সূচী",
  notification_schedule_desc: "আপনি শুধুমাত্র নির্বাচিত সময়ে পুশ ও ইমেইল বিজ্ঞপ্তি পাবেন। সেই সময়ের বাইরে সেগুলি বিরতি দেওয়া হবে।",
  learn_more: "আরও জানুন",
  allow_notifications: "বিজ্ঞপ্তি অনুমতি দিন:",
  every_day: "প্রতিদিন",
  weekdays: "সপ্তাহের দিন (সোমবার থেকে শুক্রবার)",
  custom: "কাস্টম",
  monday: "সোমবার",
  tuesday: "মঙ্গলবার",
  wednesday: "বুধবার",
  thursday: "বৃহস্পতিবার",
  friday: "শুক্রবার",
  saturday: "শনিবার",
  sunday: "রবিবার",
  to: "থেকে",
  notification_settings: "বিজ্ঞপ্তি",
  notification_settings_saved: "বিজ্ঞপ্তি সেটিংস সফলভাবে সংরক্ষণ করা হয়েছে",
  notification_settings_error: "বিজ্ঞপ্তি সেটিংস সংরক্ষণ করতে ব্যর্থ",
  unavailability_note: "অনুপলব্ধতা নোট",
  unavailability_description: "একটি আউট-অফ-অফিস নোট সেট করুন। সক্রিয় থাকাকালীন, নোটটি আপনার সমস্ত চ্যাটে অন্যদের কাছে দেখানো হয় এবং বিজ্ঞপ্তি বিরতিতে থাকে।",
  unavailability_start_date: "শুরুর তারিখ",
  unavailability_end_date: "শেষ তারিখ",
  unavailability_message: "বার্তা",
  unavailability_message_hint: "আপনার ফেরার তারিখের জন্য {endDate} প্লেসহোল্ডার হিসেবে ব্যবহার করুন।",
  unavailability_replacement: "প্রতিস্থাপন যোগাযোগ",
  unavailability_replacement_placeholder: "জরুরি অনুরোধের জন্য ব্যবহারকারী আইডি লিখুন",
  unavailability_replacement_current: "বর্তমান প্রতিস্থাপন",
  unavailability_replacement_hint: "সেট করা থাকলে, জরুরি বিষয়ে এই ব্যক্তির সাথে যোগাযোগের একটি লিংক আপনার অনুপলব্ধতা নোটে দেখানো হবে।",
  unavailability_replacement_none: "কোনো প্রতিস্থাপন নেই (ঐচ্ছিক)",
  unavailability_contact_urgent: "জরুরি অনুরোধের জন্য যোগাযোগ করুন",
  unavailability_default_message: "আমি বর্তমানে অফিসে নেই এবং Kjuup-এ অ্যাক্সেস নেই। আমি {endDate} থেকে আবার উপলব্ধ হব এবং তখন আপনার সাথে যোগাযোগ করব।",
  unavailability_save: "সংরক্ষণ করুন",
  unavailability_deactivate: "নিষ্ক্রিয় করুন",
  unavailability_active_until: "পর্যন্ত সক্রিয়",
  unavailability_saved: "অনুপলব্ধতা নোট সংরক্ষিত হয়েছে",
  unavailability_save_error: "অনুপলব্ধতা নোট সংরক্ষণ করতে ব্যর্থ",
  unavailability_deactivated: "অনুপলব্ধতা নোট নিষ্ক্রিয় করা হয়েছে",
  unavailability_end_date_required: "শেষ তারিখ আবশ্যক",
  start_time_before_end_time: "শেষ সময়ের আগে শুরু করার সময় হতে হবে",
  loading: "লোড হচ্ছে",
  disabled: "নিষ্ক্রিয়",
  enable: "সক্রিয় করুন",
  disable: "নিষ্ক্রিয় করুন",
  forwarded: "ফরওয়ার্ড করা হয়েছে",
  message_forwarded: "বার্তা ফরওয়ার্ড করা হয়েছে!",
  schedule_article_post: "নিবন্ধ পোস্ট সময়সূচী করুন",
  date: "তারিখ",
  time: "সময়",
  scheduled_for_publication: "প্রকাশনার জন্য সময়সূচী করা হয়েছে",
  article_will_be_published_on: "নিবন্ধ প্রকাশিত হবে:",
  reset_selection: "নির্বাচন রিসেট করুন",
  continue: "চালিয়ে যান",
  cancel: "বাতিল করুন",
  error_loading_members: "সদস্য লোড করতে ত্রুটি",
  please_fill_all_fields: "অনুগ্রহ করে সমস্ত ক্ষেত্র পূরণ করুন",
  invalid_email: "অবৈধ ইমেইল ঠিকানা",
  member_added_successfully: "সদস্য সফলভাবে যোগ করা হয়েছে",
  error_onboarding_user: "ব্যবহারকারী যোগ করতে ত্রুটি",
  error_creating_chat: "চ্যাট তৈরি করতে ত্রুটি",
  error_creating_group: "গ্রুপ তৈরি করতে ত্রুটি",
  new_group: "নতুন গ্রুপ",
  please_select_or_enter_group_name: "অনুগ্রহ করে একটি গ্রুপ নির্বাচন করুন বা গ্রুপের নাম লিখুন",
  please_select_or_enter_room_name: "অনুগ্রহ করে একটি প্রকল্প নির্বাচন করুন বা প্রকল্পের নাম লিখুন",
  error_creating_room: "প্রকল্প তৈরি করতে ত্রুটি",
  error_opening_chat: "চ্যাট খুলতে ত্রুটি",
  privacy_modal_text: "শুধুমাত্র \"ব্যক্তিগত\" নির্বাচন করুন যদি চ্যাটে প্রকল্প ম্যানেজারের জন্য প্রাসঙ্গিক পেশাদার সামগ্রী না থাকে।",
  not_private: "ব্যক্তিগত নয়",
  private: "ব্যক্তিগত",
  error_loading_groups: "গ্রুপ লোড করতে ত্রুটি",
  automatic_chat_export: "স্বয়ংক্রিয় চ্যাট এক্সপোর্ট",
  automatic_chat_export_info: "সক্রিয়করণের পর, চ্যাট ইতিহাস প্রতি মাসে নির্দিষ্ট ইমেইল ঠিকানায় স্বয়ংক্রিয়ভাবে পাঠানো হবে।",
  automatic_chat_export_no_email: "স্বয়ংক্রিয় চ্যাট এক্সপোর্ট সক্রিয় করতে, আপনাকে প্রথমে একটি ইমেইল ঠিকানা যোগ করতে হবে। আপনি ব্যক্তিগত সেটিংসে আপনার ইমেইল ঠিকানা যোগ করতে পারেন।",
  enter_email: "ইমেইল লিখুন",
  update: "আপডেট করুন",
  confirm: "নিশ্চিত করুন",
  export_to_email: "এক্সপোর্ট নিম্নলিখিত ইমেইলে যাবে।",
  start_chat_button: "নতুন বার্তা",
  matching_existing_chats: "বিদ্যমান চ্যাট মিলছে",
  subject: "বিষয়",
  add_subject: "বিষয় যোগ করুন",
  chat_subject: "চ্যাট বিষয়:",
  set_project_room: "প্রকল্প সেট করুন",
  matching_existing_project_rooms: "বিদ্যমান প্রকল্প মিলছে",
  name_project_room: "প্রকল্পের নাম",
  professional_or_private: "পেশাদার বা ব্যক্তিগত",
  professional: "পেশাদার",
  privacy_modal_text_updated: "শুধুমাত্র \"ব্যক্তিগত\" নির্বাচন করুন যদি চ্যাটে প্রকল্প ম্যানেজারদের জন্য প্রাসঙ্গিক পেশাদার সামগ্রী না থাকে। ব্যক্তিগত চ্যাট প্রকল্প ম্যানেজারদের কাছে দৃশ্যমান নয়।",
  create_internal_chat: "বাহ্যিক - নাকি অভ্যন্তরীণ চ্যাট?",
  internal_chat_description: "শুধুমাত্র আপনার কোম্পানির কর্মচারীদের অভ্যন্তরীণ চ্যাটে যোগ করা যেতে পারে।",
  yes: "হ্যাঁ",
  no: "না",
  chat_is_being_created: "চ্যাট তৈরি করা হচ্ছে...",
  discard_article_confirm: "আপনি কি সত্যিই এই নিবন্ধের পরিবর্তনগুলি বাতিল করতে চান?",
  please_enter_article_title: "অনুগ্রহ করে প্রথমে নিবন্ধের শিরোনাম লিখুন।",
  please_add_mandatory_fields: "অনুগ্রহ করে সমস্ত বাধ্যতামূলক ক্ষেত্র যোগ করুন",
  product_label: "পণ্য:",
  no_companies_found: "কোনও কোম্পানি পাওয়া যায়নি",
  visible_to_all_followers: "সমস্ত Kjuup সদস্যদের কাছে দৃশ্যমান",
  only_visible_to_employees: "শুধুমাত্র কর্মচারীদের কাছে দৃশ্যমান",
  something_went_wrong: "কিছু ভুল হয়েছে, অনুগ্রহ করে আবার চেষ্টা করুন",
  please_select_department: "অনুগ্রহ করে বিভাগ/অবস্থান নির্বাচন করুন",
  schedule: "সময়সূচী",
  please_select_future_date_time: "অনুগ্রহ করে নিবন্ধ সময়সূচী করার জন্য ভবিষ্যতের তারিখ এবং সময় নির্বাচন করুন।",
  please_select_different_date_time: "অনুগ্রহ করে নিবন্ধ সময়সূচী করার জন্য একটি ভিন্ন তারিখ বা সময় নির্বাচন করুন।",
  please_select_later_time: "অনুগ্রহ করে আজকের জন্য বর্তমান সময়ের চেয়ে পরে একটি সময় নির্বাচন করুন।",
  unpin_article: "নিবন্ধ আনপিন করুন",
  pin_article: "নিবন্ধ পিন করুন",
  and: "এবং",
  others: "অন্যান্য",
  at: "এ",
  mute: "মিউট করুন",
  unmute: "আনমিউট করুন",
  chat_muted_successfully: "চ্যাট সফলভাবে মিউট করা হয়েছে",
  chat_unmuted_successfully: "চ্যাট সফলভাবে আনমিউট করা হয়েছে",
  mute_chat_confirm: "আপনি কি সত্যিই এই চ্যাট মিউট করতে চান? আপনি আর নতুন বার্তার জন্য বিজ্ঞপ্তি পাবেন না।",
  unmute_chat_confirm: "আপনি কি সত্যিই এই চ্যাট আনমিউট করতে চান? আপনি আবার নতুন বার্তার জন্য বিজ্ঞপ্তি পাবেন।",
  please_select_group_to_forward: "অনুগ্রহ করে বার্তা ফরওয়ার্ড করার জন্য গ্রুপ নির্বাচন করুন",
  record_not_found: "রেকর্ড পাওয়া যায়নি!",
  please_select_position: "অনুগ্রহ করে অবস্থান নির্বাচন করুন",
  delete_article_confirm: "আপনি কি নিশ্চিত যে আপনি এই নিবন্ধটি মুছতে চান?",
  delete_company_service_confirm: "আপনি কি নিশ্চিত যে আপনি কোম্পানি পরিষেবা মুছতে চান?",
  block_translation_confirm: "আপনি কি সত্যিই কোম্পানির সমস্ত সদস্যের জন্য প্রকল্পে স্বয়ংক্রিয় অনুবাদ ব্লক করতে চান",
  unblock_translation_confirm: "আপনি কি সত্যিই কোম্পানির সমস্ত সদস্যের জন্য প্রকল্পে স্বয়ংক্রিয় অনুবাদ আনব্লক করতে চান",
  please_select_file: "অনুগ্রহ করে আপলোড করার জন্য একটি ফাইল নির্বাচন করুন",
  role_in_building_industry: "নির্মাণ শিল্পে ভূমিকা*",
  invalid_email_address: "অবৈধ ইমেইল ঠিকানা",
  please_enter_password: "অনুগ্রহ করে পাসওয়ার্ড লিখুন",
  password_change_email_sent: "আপনার Kjuup ইমেইলে একটি ইমেইল পাঠানো হয়েছে। ইমেইলের নিশ্চিতকরণ লিঙ্কে ক্লিক করে আপনার নতুন পাসওয়ার্ড নিশ্চিত করুন।",
  please_enter_username: "অনুগ্রহ করে ব্যবহারকারীর নাম লিখুন",
  username_same_as_before: "ব্যবহারকারীর নাম আগের মতো একই হতে পারে না",
  profile_deleted_successfully: "প্রোফাইল সফলভাবে মুছে দেওয়া হয়েছে",
  hardware_requirements: "হার্ডওয়্যার প্রয়োজনীয়তা",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU গতি ন্যূনতম 2GHz<br/>• Windows 7 বা উচ্চতর / সমস্ত macOS সংস্করণ",
  submitting: "জমা দেওয়া হচ্ছে...",
  signing_in: "সাইন ইন করা হচ্ছে...",
  please_enter_service_name: "অনুগ্রহ করে পরিষেবার নাম লিখুন",
  something_went_wrong_error: "আহ! কিছু ভুল হয়েছে...",
  something_went_wrong_try_again: "দুঃখিত, সেখানে কিছু ভুল হয়েছে। আবার চেষ্টা করুন",
  position_label: "অবস্থান:",
  loading_room: "প্রকল্প লোড হচ্ছে...",
  navigating_to_room: "প্রকল্পে নেভিগেট করা হচ্ছে",
  loading_chat: "চ্যাট লোড হচ্ছে...",
  translate: "অনুবাদ করুন",
  show_original: "মূল দেখান",
  saving: "সংরক্ষণ করা হচ্ছে...",
  language_selection_info: "ভাষা নির্বাচন কোম্পানি সম্পর্কিত সমস্ত ইমেইল নিশ্চিতকরণের জন্য ব্যবহার করা হয়।",
  nav_call: "কল",
  nav_home: "হোম",
  nav_messages: "বার্তা",
  nav_todo: "করণীয়গুলো",
  nav_rooms: "প্রকল্প",
  nav_all_rooms: "সব প্রকল্প",
  pinned_rooms_max: "আপনি সর্বোচ্চ ১০টি প্রকল্প পিন করতে পারেন।",
  pinned_room_unpin: "আনপিন",
  pinned_rooms_drop: "দ্রুত নির্বাচনের জন্য আপনার প্রকল্প এখানে টেনে আনুন",
  nav_profile: "প্রোফাইল",
  nav_company: "কোম্পানি",
  nav_company_documents: "নথি",
  nav_logout: "লগআউট",
  add_member_title: "সদস্য যোগ করুন",
  continue_btn: "চালিয়ে যান",
  search_placeholder: "খুঁজুন",
  no_members_found: "কোনও সদস্য পাওয়া যায়নি",
  no_groups_found: "কোনও গ্রুপ পাওয়া যায়নি",
  no_rooms_found: "কোনও প্রকল্প পাওয়া যায়নি",
  search_users_tab: "ব্যবহারকারী",
  search_documents_tab: "নথি",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "কোনো ফাইল নেই",
  no_documents_available: "No documents",
  searching_users: "ব্যবহারকারী অনুসন্ধান করা হচ্ছে...",
  no_users_found: "কোনো ব্যবহারকারী পাওয়া যায়নি",
  search_emails_tab: "ইমেইল",
  searching_emails: "ইমেইল খোঁজা হচ্ছে...",
  no_emails_found: "কোনো ইমেইল পাওয়া যায়নি",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "নামহীন গ্রুপ",
  unnamed_room: "নামহীন প্রকল্প",
  all_members: "সব",
  room_label: "প্রকল্প:",
  subject_label: "বিষয়:",
  no_members: "কোনও সদস্য নেই",
  creating_structure: "আপনার কাঠামো তৈরি করা হচ্ছে",
  opening_chat: "চ্যাট খোলা হচ্ছে",
  please_wait: "অনুগ্রহ করে অপেক্ষা করুন...",
  loading_todo: "ToDo লোড হচ্ছে...",
  task_updated: "কাজ আপডেট করা হয়েছে",
  error_updating_task: "কাজ আপডেট করতে ত্রুটি",
  task_deleted: "কাজ মুছে দেওয়া হয়েছে",
  error_deleting_task: "কাজ মুছে দিতে ত্রুটি",
  delete_task_confirm: "আপনি কি নিশ্চিত যে আপনি এই কাজটি মুছতে চান?",
  description_label: "বিবরণ",
  description_placeholder: "বিবরণ লিখুন...",
  date_time_label: "তারিখ এবং সময়",
  save_hint: "সংরক্ষণ করতে Ctrl+Enter, বাতিল করতে Esc",
  edit_label: "সম্পাদনা করুন",
  delete_label: "মুছুন",
  todo_list_title: "করণীয়গুলো",
  tasks_count: "কাজ",
  search_placeholder_todo: "খুঁজুন...",
  select_task_to_open_chat: "চ্যাট খুলতে একটি কাজ নির্বাচন করুন",
  today: "আজ",
  yesterday: "গতকাল",
  time_suffix: "",
  from_chat: "সোর্স ToDo",
  assigned_to: "নির্ধারিত",
  assign_users: "ব্যবহারকারী নির্ধারণ করুন",
  no_users_assigned: "কোনও ব্যবহারকারী নির্ধারিত নেই",
  assign: "নির্ধারণ করুন",
  assign_to: "নির্ধারণ করুন...",
  navigate_to_chat: "চ্যাটে নেভিগেট করুন",
  navigate_to_email: "ইমেইলে নেভিগেট করুন",
  show_original_message: "সোর্স দেখান",
  hide_original_message: "সোর্স লুকান",
  status_pending: "বিচারাধীন",
  status_in_progress: "চলমান",
  status_completed: "সম্পূর্ণ",
  show: "দেখান",
  close: "বন্ধ করুন",
  status_confirmed: "[নিশ্চিত]",
  log_todo_created: "ToDo [তৈরি করা হয়েছে]",
  log_todo_confirmed: "ToDo [নিশ্চিত করা হয়েছে]",
  log_todo_deleted: "ToDo [মুছে ফেলা হয়েছে]",
  log_todo_updated: "ToDo [আপডেট করা হয়েছে]",
  log_description_updated: "[বিবরণ আপডেট করা হয়েছে]",
  log_deadline_updated: "[সময়সীমা আপডেট করা হয়েছে]",
  log_assigned_to: "[নিয়োগ করা হয়েছে] {name}",
  log_unassigned_from: "[নিয়োগ বাতিল করা হয়েছে] {name}",
  log_assignment_added: "[নিয়োগ যোগ করা হয়েছে]: {name}",
  log_assignment_removed: "[নিয়োগ সরানো হয়েছে]: {name}",
  log_status_updated: "[স্থিতি পরিবর্তন করা হয়েছে] {from} [থেকে] {to}",
  log_status_changed: "[স্থিতি পরিবর্তন করা হয়েছে]",
  log_status_changed_to: "[স্থিতি পরিবর্তন করা হয়েছে] {status}",
  log_changed_status_to: "[স্থিতি পরিবর্তন করা হয়েছে]:",
  log_for_user: "[ব্যবহারকারীর জন্য]:",
  log_user_updated_status: "[ব্যবহারকারী তাদের todo স্থিতি আপডেট করেছে]",
  log_changed_date_to: "[তারিখ পরিবর্তন করা হয়েছে]:",
  log_changed_description_to: "[বিবরণ পরিবর্তন করা হয়েছে]:",
  log_moved_to: "[স্থানান্তরিত হয়েছে] {status}",
  todo_status_updated_from: "[থেকে]",
  todo_status_updated_to: "[থেকে]",
  filter_pending: "অপেক্ষমাণ",
  filter_confirmed: "নিশ্চিত",
  filter_assigned_to_me: "আমার কাজ",
  filter_assigned_by_me: "অর্পিত",
  todo_project_label: "প্রকল্প:",
  assigned_users: "নির্ধারিত ব্যবহারকারী:",
  todo_chat_label: "চ্যাট:",
  history: "ইতিহাস",
  todo_assigned_by: "অর্পণকারী:",
  todo_assigned_push: "অ্যাসাইন করা ToDo:",
  todo_assigned_push_empty: "আপনাকে একটি নতুন ToDo অ্যাসাইন করা হয়েছে।",
  search_groups: "গ্রুপ",
  search_chat_groups: "চ্যাট গ্রুপ",
  search_project_room: "প্রকল্প",
  search_messages_tab: "বার্তা",
  searching_groups: "গ্রুপ খোঁজা হচ্ছে...",
  searching_rooms: "প্রকল্প খোঁজা হচ্ছে...",
  no_groups_found: "কোনো গ্রুপ পাওয়া যায়নি",
  no_rooms_found: "কোনো প্রকল্প পাওয়া যায়নি",
  create_poll: "Poll",
  poll_question_label: "QUESTION",
  poll_question_placeholder: "Ask a question",
  poll_options_label: "OPTIONS",
  poll_option: "Option",
  poll_add_option: "Add option",
  poll_allow_multiple: "Allow multiple answers",
  poll_multiple_allowed: "Select one or more options",
  poll_select_option: "Select one option",
  poll_view_votes: "View votes",
  poll_vote_singular: "vote",
  poll_vote_plural: "votes",
  poll_votes: "Poll votes",
  poll_no_votes_yet: "No votes yet",
  transcript_step_processing: "ট্রান্সক্রিপশন চলছে...",
  ai_transcript_tab: "AI-ট্রান্সক্রিপ্ট",
  ai_transcript_info: "শুধুমাত্র 09.03.2026 এর পরে তৈরি করা ভয়েস বার্তাগুলির জন্য উপলব্ধ।",
  transcript_more: "...আরও",
  transcript_less: "...কম",
  ki_transcript_voice_message: "KI-ভয়েস মেসেজের ট্রান্সক্রিপ্ট",
  ki_image_analysis: "AI-চালিত চিত্র বিশ্লেষণ",
  type_message: "একটি বার্তা লিখুন",
  email_tab_messages: "বার্তা",
  email_tab_email: "ইমেইল",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "ইমেইল অ্যাকাউন্ট",
  email_connect_gmail: "Gmail সংযুক্ত করুন",
  email_connect_outlook: "Outlook সংযুক্ত করুন",
  email_no_accounts: "কোন ইমেইল অ্যাকাউন্ট সংযুক্ত নেই",
  email_no_accounts_hint: "আপনার প্রোফাইল সেটিংসে ইমেইল অ্যাকাউন্ট সংযুক্ত করুন",
  email_no_messages: "কোন ইমেইল নেই",
  email_from: "থেকে",
  email_to: "প্রতি",
  email_subject: "বিষয়",
  email_disconnect: "সংযোগ বিচ্ছিন্ন করুন",
  email_disconnect_confirm: "আপনি কি নিশ্চিত যে আপনি এই ইমেল অ্যাকাউন্টটি সংযোগ বিচ্ছিন্ন করতে চান? সমস্ত সিঙ্ক করা ইমেল সরানো হবে।",
  email_account_disconnected: "ইমেইল অ্যাকাউন্ট সফলভাবে সংযোগ বিচ্ছিন্ন করা হয়েছে",
  email_account_disconnect_failed: "অ্যাকাউন্ট সংযোগ বিচ্ছিন্ন করতে ব্যর্থ",
  email_connecting: "সংযুক্ত হচ্ছে...",
  email_account_connected: "অ্যাকাউন্ট সফলভাবে সংযুক্ত হয়েছে",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "সেটিংসে যান",
  email_date: "তারিখ",
  email_reply: "উত্তর দিন",
  email_forward: "ফরওয়ার্ড করুন",
  email_copy_text: "টেক্সট কপি করুন",
  email_text_copied: "কপি হয়েছে!",
  email_text_copy_failed: "টেক্সট কপি করা যায়নি।",
  email_delete: "মুছুন",
  email_not_spam: "স্প্যাম নয়",
  email_not_spam_success: "ইমেল ইনবক্সে সরানো হয়েছে।",
  email_not_spam_failed: "ইনবক্সে সরানো যায়নি।",
  email_delete_confirm: "আপনি কি এই ইমেলটি মুছে ফেলতে চান?",
  email_delete_from_folder: "আপনি কি {folder} থেকে মুছে ফেলতে নিশ্চিত?",
  email_delete_permanent_from_folder:
    "আপনি কি {folder} থেকে স্থায়ীভাবে মুছে ফেলতে নিশ্চিত? এই কাজটি পূর্বাবস্থায় ফেরানো যাবে না।",
  email_save_draft_confirm: "এই ইমেলটি খসড়া হিসেবে সংরক্ষণ করতে চান?",
  email_save_draft: "খসড়া সংরক্ষণ",
  email_discard: "বাতিল",
  email_back_to_compose: "লেখায় ফিরে যান",
  email_draft_saved: "খসড়া সংরক্ষিত হয়েছে।",
  email_draft_save_failed: "খসড়া সংরক্ষণ করতে ব্যর্থ।",
  email_loading: "ইমেইল লোড হচ্ছে...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Select",
  email_attachment_singular: "Attachment",
  email_attachment_plural: "Attachments",
  email_back: "Back",
  email_download: "Download",
  email_close: "Close",
  email_preview: "Preview",
  email_preview_not_available: "পূর্বরূপ উপলব্ধ নয়",
  email_preview_failed: "পূর্বরূপ উপলব্ধ নয়",
  select_attachments: "সংযুক্তি নির্বাচন করুন",
  email_loading_preview: "Loading preview...",
  email_mark_unread_failed: "email(s) could not be marked as unread.",
  email_delete_failed: "email(s) could not be deleted.",
  filter_all: "সমস্ত",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "সরাসরি বার্তা",
  my_notes: "My Space",
  filter_internal_groups: "অভ্যন্তরীণ গ্রুপ চ্যাট",
  filter_external_groups: "বহিরাগত গ্রুপ চ্যাট",
  filter_group_chats: "গ্রুপ চ্যাট",
  filter_groups_internal: "অভ্যন্তরীণ",
  filter_groups_external: "বহিরাগত",
  filter_unread_only: "শুধু অপঠিত",
  room_daily_briefing_info: "সক্রিয় থাকলে, ব্যক্তিগত সেটিংসে নির্ধারিত সময়ে প্রতি ২৪ ঘণ্টায় এই প্রকল্পের একটি রিপোর্ট তৈরি হয় — তবে কেবল তখনই যদি সেই সময়ে কোনো কার্যকলাপ থাকে।",
  email_select_all: "সব নির্বাচন করুন",
  email_deselect_all: "সব অনির্বাচন করুন",
  email_reply_all: "সবাইকে উত্তর দিন",
  email_reply_placeholder: "আপনার উত্তর টাইপ করুন...",
  email_forward_placeholder: "একটি বার্তা যোগ করুন...",
  email_edit_draft: "খসড়া সম্পাদনা করুন",
  email_attach: "সংযুক্ত করুন",
  email_attachment_from_original: "মূল বার্তা থেকে",
  email_remove: "সরান",
  email_drop_files: "সংযুক্ত করতে ফাইল ড্রপ করুন",
  email_loading_attachments: "সংযুক্তি লোড হচ্ছে...",
  email_archive: "আর্কাইভ",
  mark_unread: "অপঠিত হিসাবে চিহ্নিত করুন",
  mark_read: "পঠিত হিসাবে চিহ্নিত করুন",
  email_all_accounts: "সব অ্যাকাউন্ট",
  email_error: "ত্রুটি",
  email_delete_email_failed: "ইমেল মুছতে ব্যর্থ।",
  enter_url: "URL লিখুন",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'এখনই সাবস্ক্রাইব করুন',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '১ মাস ফ্রি ট্রায়াল',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'আজ কোনো পেমেন্ট নেই। পেইড সাবস্ক্রিপশন শুরু হওয়ার আগে ক্রেডিট কার্ডের তথ্য চাওয়া হয় না।',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'সব ইমেইল অ্যাকাউন্ট সরাসরি Kjuup-এ পরিচালনা করুন',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI উত্তর লেখে – আপনি শুধু নিশ্চিত করেন',
  kjuup_io_feature_tasks: 'টাস্ক ও ক্যালেন্ডার সবসময় স্বয়ংক্রিয়ভাবে আপডেট',
  kjuup_io_choose_plan: 'প্ল্যান বেছে নিন',
  kjuup_io_plan_monthly: 'মাসিক',
  kjuup_io_plan_yearly: 'বার্ষিক',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Stripe দ্বারা সুরক্ষিত · যেকোনো সময় বাতিল করুন',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'পেমেন্ট পাওয়া গেছে। আপনার সাবস্ক্রিপশন সক্রিয় করা হচ্ছে…',
  kjuup_io_toast_activating_soon: 'পেমেন্ট পাওয়া গেছে। আপনার সাবস্ক্রিপশন শীঘ্রই সক্রিয় হবে।',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} ঘণ্টা বাকি',
  kjuup_io_trial_left_hour: '1 ঘণ্টা বাকি',
  kjuup_io_trial_left_minutes: '{count} মিনিট বাকি',
  kjuup_io_trial_left_minute: '1 মিনিট বাকি',
  kjuup_io_trial_left_seconds: '{count} সেকেন্ড বাকি',
  kjuup_io_trial_left_second: '1 সেকেন্ড বাকি',
  kjuup_io_trial_ending_now: 'আপনার ট্রায়াল শেষ হচ্ছে…',
  kjuup_io_request_timeout: 'সংযোগের সময় শেষ হয়েছে। আবার চেষ্টা করুন।',
  kjuup_io_info_days_free: '{days} দিন সম্পূর্ণ ফ্রি – ট্রায়ালের পরেই সাবস্ক্রিপশন শুরু হয়।',
  kjuup_io_discount_total: 'আপনার ছাড়: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'ব্যক্তিগত: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'বন্ধ করুন',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'আপনার বিনামূল্যের ট্রায়াল শেষ হয়েছে',
  kjuup_io_trial_ended_body: 'ইমেল ও অন্যান্য প্রিমিয়াম ফিচার ব্যবহার চালিয়ে যেতে Kjuup.io সাবস্ক্রাইব করুন।',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'আপনার বিনামূল্যের ট্রায়াল শুরু হয়েছে',
  kjuup_io_toast_trial_fail: 'বিনামূল্যের ট্রায়াল শুরু করা যায়নি',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / মাস',
  kjuup_io_save_amount_year: 'প্রতি বছর {price} সাশ্রয়',
  kjuup_io_billed_annually_amount: '{price} বার্ষিক বিল',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'আপনি যা পাবেন:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'ক্রেডিট কার্ড লাগবে না – পেমেন্ট তথ্য ছাড়াই এখনই শুরু করুন।',
  kjuup_io_info_cancel_anytime: 'যেকোনো সময় বাতিল – কোনো বাধ্যবাধকতা নেই, কোনো ঝুঁকি নেই।',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'বিলিং সময়কাল',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'পেমেন্ট পদ্ধতি সংরক্ষিত হয়েছে। ট্রায়াল শেষ হলে চার্জ করা হবে।',
  calendar_sync_info: 'সব Kjuup ToDo আপনার ক্যালেন্ডারের সাথে স্বয়ংক্রিয়ভাবে সিঙ্ক করুন।',
  calendar_no_accounts: 'এখনও কোনো ক্যালেন্ডার সংযুক্ত নেই।',
  article_new_badge: 'নতুন',
  article_new_posts: '{0}টি নতুন পোস্ট',
  documents: 'নথিপত্র',
  add_documents: 'নথি যোগ করুন',
  no_preview_available: 'কোনো প্রিভিউ উপলব্ধ নেই',
  no_preview_hint: 'এই ধরনের ফাইলের প্রিভিউ দেখানো যায় না, তবে এটি পাঠানো হবে।',
  max_documents_reached: 'আপনি একবারে সর্বাধিক ১০টি নথি সংযুক্ত করতে পারেন।',
  open_file: 'ফাইল খুলুন',
  twofa_title: 'দুই-ধাপের যাচাইকরণ',
  twofa_method_totp: 'অথেন্টিকেটর অ্যাপ',
  twofa_method_sms: 'টেক্সট মেসেজ',
  twofa_method_email: 'ইমেল',
  twofa_enter_app: 'অথেন্টিকেটর অ্যাপ থেকে ৬ সংখ্যার কোড লিখুন।',
  twofa_enter_sms: 'এসএমএসে পাঠানো ৬ সংখ্যার কোড লিখুন।',
  twofa_enter_email: 'ইমেলে পাঠানো ৬ সংখ্যার কোড লিখুন।',
  twofa_resend: 'কোড আবার পাঠান',
  twofa_try_another: 'অন্য পদ্ধতি চেষ্টা করুন',
  twofa_remember_device: 'এই ডিভাইসে ৩০ দিন জিজ্ঞাসা করবেন না',
  twofa_sent: 'আমরা একটি কোড পাঠিয়েছি।',
  twofa_invalid_code: 'এই কোডটি ভুল। আবার চেষ্টা করুন।',
  twofa_something_wrong: 'কিছু ভুল হয়েছে। আবার চেষ্টা করুন।',
  twofa_method_unavailable: 'এই যাচাইকরণ পদ্ধতি নেই।',
  twofa_on_desc: 'দুই-ধাপের যাচাইকরণ চালু। প্রতিবার সাইন ইনে কোড লাগবে।',
  twofa_off_desc: 'পাসওয়ার্ডের পর দ্বিতীয় ধাপ যোগ করুন। অথেন্টিকেটর অ্যাপ সবচেয়ে নিরাপদ।',
  twofa_methods: 'পদ্ধতি',
  twofa_on: 'চালু',
  twofa_add: 'যোগ করুন',
  twofa_default_method: 'ডিফল্ট পদ্ধতি',
  twofa_default: 'ডিফল্ট',
  twofa_turn_off: 'বন্ধ করুন',
  twofa_disable_hint: 'দুই-ধাপের যাচাইকরণ বন্ধ করতে পাসওয়ার্ড ও বর্তমান কোড লিখুন।',
  twofa_disable_need: 'পাসওয়ার্ড ও যাচাইকরণ কোড লিখুন।',
  twofa_code_placeholder: '৬ সংখ্যার কোড বা ব্যাকআপ কোড',
  twofa_send_code: 'কোড পাঠান',
  twofa_primary_updated: 'ডিফল্ট পদ্ধতি আপডেট হয়েছে।',
  twofa_disabled: 'দুই-ধাপের যাচাইকরণ এখন বন্ধ।',
  twofa_enabled: 'দুই-ধাপের যাচাইকরণ এখন চালু।',
  twofa_totp_help: 'Google Authenticator, Authy বা 1Password দিয়ে এই QR কোড স্ক্যান করুন। চাবি হাতেও লেখা যায়।',
  twofa_secret_copied: 'চাবি কপি হয়েছে',
  twofa_sms_help: 'আন্তর্জাতিক ফরম্যাটে মোবাইল নম্বর লিখুন। আমরা ৬ সংখ্যার কোড এসএমএসে পাঠাব।',
  twofa_email_help: 'আমরা আপনার অ্যাকাউন্টের ইমেলে ৬ সংখ্যার কোড পাঠাব।',
  twofa_backup_title: 'ব্যাকআপ কোড',
  twofa_backup_help: 'এই একবারের কোড নিরাপদ জায়গায় রাখুন। ফোন হারালে প্রতিটি কোড একবার ব্যবহার করা যায়।',
  twofa_copy_codes: 'কোড কপি করুন',
  twofa_codes_copied: 'ব্যাকআপ কোড কপি হয়েছে',
  twofa_regenerate: 'নতুন ব্যাকআপ কোড নিন',
  twofa_regenerate_hint: 'এতে অব্যবহৃত ব্যাকআপ কোডগুলো প্রতিস্থাপিত হবে। পাসওয়ার্ড এবং একটি বর্তমান কোড লিখুন।',
  twofa_backup_remaining: '{n}টি অব্যবহৃত ব্যাকআপ কোড বাকি',
  twofa_new_codes: 'নতুন ব্যাকআপ কোড',
  twofa_sms_unavailable: 'এসএমএস কোড এখনো পাওয়া যাচ্ছে না।',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "তোমাকে দেওয়া Kjuup কাজগুলো তোমার Todoist-এর Kjuup প্রজেক্টে কপি হয়। Todoist-এ করা পরিবর্তন ফিরে কপি হয় না।",
  todoist_connect: "Todoist সংযুক্ত করো",
  todoist_connected: "Todoist সংযুক্ত হয়েছে",
  todoist_connect_failed: "Todoist সংযোগ ব্যর্থ",
  todoist_disconnect: "সংযোগ বিচ্ছিন্ন",
  todoist_disconnected: "Todoist সংযোগ বিচ্ছিন্ন হয়েছে",
  todoist_disconnect_confirm: "Todoist সংযোগ বিচ্ছিন্ন করবে? Todoist-এ থাকা কাজগুলো থেকে যায়। সিঙ্ক বন্ধ হয়।",
  todoist_sync_now: "এখন সিঙ্ক করো",
  todoist_syncing: "সিঙ্ক হচ্ছে…",
  todoist_sync_done: "সিঙ্ক শেষ",
  todoist_sync_failed: "সিঙ্ক ব্যর্থ",
  todoist_auth_error: "সিঙ্ক চালিয়ে যেতে Todoist আবার সংযুক্ত করো।",
  todoist_last_sync: "শেষ সিঙ্ক",
  todoist_not_connected: "Todoist সংযুক্ত নয়",
  todoist_auth_url_failed: "Todoist অনুমতি পৃষ্ঠা খোলা যায়নি।",
  recommend_text: "Kjuup-এ যোগ দাও, যুক্ত থাকো আর তোমার যোগাযোগ গুছিয়ে রাখো। তোমার সব চ্যানেল এক জায়গায় আনো, মেসেজগুলো সঠিক প্রজেক্টে রাখো, আর প্রতিটি সকাল শুরু করো একটি সারাংশ ও তোমার কাজগুলো দিয়ে – সবকিছু সিঙ্ক থাকে তোমার আগে থেকে ব্যবহার করা অ্যাপগুলোর সাথে। বিনামূল্যে শুরু করো:",
  pro_auth_signin_title: 'আবার স্বাগতম',
  pro_auth_signin_sub: 'আপনার কাজের ইমেইল দিয়ে সাইন ইন করুন।',
  pro_auth_email_or_username: 'ইমেইল বা ইউজারনেম',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: 'পাসওয়ার্ড ভুলে গেছেন?',
  pro_auth_create_account: 'অ্যাকাউন্ট তৈরি করুন',
  pro_auth_show_password: 'পাসওয়ার্ড দেখান',
  pro_auth_hide_password: 'পাসওয়ার্ড লুকান',
  pro_auth_register_sub: 'আপনার ইমেইল নিশ্চিত করতে আমরা একটি লিংক পাঠাব।',
  pro_auth_register_plus_sub: 'একটি ইউজারনেম ও পাসওয়ার্ড বেছে নিন। এরপর আপনার নিরাপত্তা PIN সেট করবেন।',
  pro_auth_check_credentials: 'আপনার ইমেইল ও পাসওয়ার্ড যাচাই করুন',
  pro_news_export_pdf: 'PDF হিসেবে এক্সপোর্ট করুন',
  pro_news_pdf_failed: 'PDF তৈরি করা যায়নি।',
  pro_news_pdf_attachments: 'সংযুক্তি',
  pro_news_pdf_video: 'ভিডিও',
  pro_auth_forgot_sub: 'আপনার ইমেইল লিখুন, আমরা পাসওয়ার্ড রিসেট করার লিংক পাঠাব।',
  pro_auth_send_link: 'রিসেট লিংক পাঠান',
  pro_auth_plus_reset: 'PIN দিয়ে রিসেট করুন',
  pro_auth_show_pin: 'PIN দেখান',
  pro_auth_hide_pin: 'PIN লুকান',
  v2_auth_plus_only: 'শুধু Kjuup+',
  room_action_media: "ফাইল",
  room_tab_overview: "সংক্ষিপ্ত বিবরণ",
  room_tab_history: "ইতিহাস",
  chat_info_media: "ফাইল",
  messages: "বার্তা",
  pro_todo_project_required: "অনুগ্রহ করে একটি প্রকল্প বেছে নিন",
  pro_todo_choose_project: "এই কাজটি কোন প্রকল্পের জন্য?",
  cockpit_report_delete_confirm: "এই দৈনিক রিপোর্ট মুছবেন?",
  cockpit_report_deleted: "দৈনিক রিপোর্ট মুছে ফেলা হয়েছে",
  cockpit_tab_company: "কোম্পানি",
  cockpit_bookmarked_priorities: "বুকমার্ক করা কাজ",
  cockpit_load_error: "ককপিট লোড করা যায়নি।",
  cockpit_retry: "আবার চেষ্টা করুন",
  cockpit_yesterday: "গতকাল",
  cockpit_greeting_morning: "সুপ্রভাত",
  cockpit_greeting_day: "শুভ অপরাহ্ন",
  cockpit_greeting_evening: "শুভ সন্ধ্যা",
  cockpit_assistant_q_open: "আজ কী বাকি আছে?",
  cockpit_assistant_q_summarize: "{{room}} চ্যাটের সারসংক্ষেপ দিন",
  cockpit_assistant_q_overdue: "কোন কাজগুলো বিলম্বিত?",
  cockpit_assistant_new: "{{n}}টি নতুন",
  cockpit_assistant_important: "{{n}}টি গুরুত্বপূর্ণ",
  cockpit_assistant_title: "Kjuup সহকারী",
  cockpit_assistant_hint: "ট্যাপ করুন এবং জিজ্ঞাসা করুন",
  room_overview_priority_no_detail: "রিপোর্টে এই অগ্রাধিকার সম্পর্কে আর কোনো বিস্তারিত নেই।",
  room_overview_priority_from: "সূত্র: {{name}}",
  room_overview_priority_open_task: "কাজ খুলুন",
  cockpit_priority_position: "{{total}}টির মধ্যে {{index}}টি অগ্রাধিকার",
  room_overview_today_title: "আজ গুরুত্বপূর্ণ",
  room_overview_all_tasks: "সব",
  room_overview_tasks_empty: "কোনো খোলা সময়সীমা বা কাজ নেই",
  room_overview_appointments_empty: "কোনো আসন্ন অ্যাপয়েন্টমেন্ট নেই",
  room_overview_no_priorities: "সর্বশেষ রিপোর্টে কোনো খোলা অগ্রাধিকার নেই।",
  cockpit_report_top5: "শীর্ষ ৫ অগ্রাধিকার",
  cockpit_report_todo_created: "ToDo তৈরি হয়েছে",
  cockpit_report_source_missing: "সূত্র বার্তা পাওয়া যায়নি।",
  delete_bookmarked_priority_confirm: "আপনি কি নিশ্চিতভাবে এই বুকমার্ক করা কাজটি মুছতে চান?",
  cockpit_report_create_todo: "ToDo তৈরি করুন",
  cockpit_priorities_deleting: "মুছে ফেলা হচ্ছে …",
  cockpit_priorities_select: "একাধিক মুছুন",
  cockpit_report_none: "কোনো এন্ট্রি নেই।",
  cockpit_priorities_delete_confirm: "আপনি কি নিশ্চিতভাবে {count}টি বুকমার্ক করা কাজ মুছতে চান?",
  cockpit_priorities_delete_failed: "{count}টি কাজ মোছা যায়নি",
  cockpit_priorities_deleted: "{count}টি কাজ মুছে ফেলা হয়েছে",
  cockpit_priorities_selected: "{count}টি নির্বাচিত",
  cockpit_channel_connected: "সংযুক্ত",
  cockpit_channel_not_connected: "সংযুক্ত নয়",
  cockpit_channel_connect: "সংযুক্ত করুন",
  cockpit_channel_chat: "Kjuup চ্যাট",
  cockpit_channel_active: "সক্রিয়",
  cockpit_channel_hidden: "লুকানো",
  cockpit_channel_enable: "চালু করুন",
  cockpit_channel_email: "ইমেল",
  cockpit_channel_check: "সংযোগ যাচাই করুন",
  cockpit_channel_fix: "যাচাই করুন",
  cockpit_channel_forward: "ফরওয়ার্ডিং ঠিকানা",
  cockpit_channel_not_set_up: "সেট আপ করা হয়নি",
  cockpit_channel_set_up: "সেট আপ করুন",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "সংযোগ বিচ্ছিন্ন হয়েছে",
  cockpit_channel_importing: "আমদানি হচ্ছে",
  cockpit_channel_removing: "সংযোগ বিচ্ছিন্ন করা হচ্ছে",
  cockpit_channel_reconnect: "আবার সংযুক্ত করুন",
  cockpit_channels_title: "চ্যানেল",
  cockpit_company_role_super_admin: "কোম্পানি অ্যাডমিন",
  cockpit_company_role_dept_admin: "বিভাগ অ্যাডমিন",
  cockpit_company_role_member: "কর্মচারী",
  cockpit_company_none: "কোনো Kjuup+ কোম্পানি পাওয়া যায়নি",
  cockpit_company_eyebrow: "কোম্পানি",
  cockpit_company_inactive: "নিষ্ক্রিয়",
  cockpit_company_settings: "কোম্পানির সেটিংস",
  cockpit_company_employees: "কর্মচারীরা",
  cockpit_company_internal_rooms: "অভ্যন্তরীণ প্রকল্প",
  cockpit_report_all_projects: "সব প্রকল্প",
  cockpit_report_progress_emails: "ইমেল বিশ্লেষণ করা হচ্ছে",
  cockpit_report_progress_chats: "চ্যাট বার্তা বিশ্লেষণ করা হচ্ছে",
  cockpit_report_progress_documents: "সংযুক্তি ও নথি বিশ্লেষণ করা হচ্ছে",
  cockpit_report_progress_tasks: "কাজ বিশ্লেষণ করা হচ্ছে",
  cockpit_report_progress_summarizing: "বিষয়বস্তু বিশ্লেষণ করা হচ্ছে",
  cockpit_report_progress_reading: "আগে বিশ্লেষণ করা বিষয়বস্তু পুনরায় ব্যবহার করা হচ্ছে",
  cockpit_report_progress_collecting: "আপনার প্রকল্পগুলো থেকে ইমেল, চ্যাট ও কাজ সংগ্রহ করা হচ্ছে",
  cockpit_report_progress_priorities: "অগ্রাধিকার, সময়সীমা ও সিদ্ধান্ত একত্র করা হচ্ছে",
  cockpit_report_progress_queued: "রিপোর্ট প্রস্তুত করা হচ্ছে",
  cockpit_report_creating_title: "আপনার দৈনিক রিপোর্ট প্রস্তুত করা হচ্ছে",
  cockpit_report_progress_count_one: "১টি আইটেম বিশ্লেষণ হয়েছে",
  cockpit_report_progress_count_many: "{{count}}টি আইটেম বিশ্লেষণ হয়েছে",
  cockpit_report_progress_hint: "এতে সাধারণত এক থেকে দুই মিনিট লাগে – এর মধ্যে আপনি ককপিট ব্যবহার চালিয়ে যেতে পারেন।",
  cockpit_report_time_hint: "দৈনিক রিপোর্ট প্রতিদিন {{hour}}:00 টায় সবচেয়ে সক্রিয় পাঁচটি প্রকল্পের জন্য তৈরি হয়।",
  room_overview_priorities_title: "বর্তমান অবস্থা ও অগ্রাধিকার",
  room_overview_as_of: "{{time}} পর্যন্ত",
  cockpit_report_delete: "দৈনিক রিপোর্ট মুছুন",
  email_tag_daily_briefing: "দৈনিক রিপোর্ট",
  cockpit_report_unread: "নতুন",
  cockpit_report_clear_project: "সব প্রকল্প দেখান",
  cockpit_filter_project: "প্রকল্প",
  cockpit_filter_all_projects: "সব প্রকল্প",
  cockpit_report_recreate: "দৈনিক রিপোর্ট আবার তৈরি করুন",
  cockpit_report_hide_previous: "আগের দৈনিক রিপোর্ট লুকান",
  cockpit_report_show_previous: "আগের দৈনিক রিপোর্ট দেখান",
  cockpit_report_room_empty: "এই প্রকল্পের এখনও কোনো দৈনিক রিপোর্ট নেই",
  cockpit_report_empty: "এখনও কোনো দৈনিক রিপোর্ট নেই",
  cockpit_report_room_empty_hint: "শুধু এই প্রকল্পের জন্য দৈনিক রিপোর্ট তৈরি করুন।",
  cockpit_report_needs_mailbox: "একটি ইমেল অ্যাকাউন্ট সংযুক্ত করুন, যাতে Kjuup স্বয়ংক্রিয় কাজসহ দৈনিক রিপোর্ট তৈরি করতে পারে।",
  cockpit_report_create: "দৈনিক রিপোর্ট তৈরি করুন",
  cockpit_email_connect: "ইমেল সংযুক্ত করুন",
  cockpit_email_none_title: "এখনও কোনো ইমেল অ্যাকাউন্ট সংযুক্ত নেই",
  cockpit_email_none_reports: "আপনার মেইলবক্স সংযুক্ত করুন, যাতে Kjuup আসা ইমেলগুলো আপনার প্রকল্পে বরাদ্দ করতে এবং কাজসহ দৈনিক রিপোর্ট তৈরি করতে পারে।",
  cockpit_email_none_client: "Kjuup.io-তেই সরাসরি ইমেল পড়তে, বরাদ্দ করতে ও উত্তর দিতে Gmail, Outlook বা IMAP সংযুক্ত করুন।",
  cockpit_email_reports_title: "বর্তমান ইমেল ক্লায়েন্ট",
  cockpit_email_reports_text: "Kjuup.io-তে কোনো ইনবক্স নেই · {{rooms}}টি প্রকল্প, দৈনিক রিপোর্ট {{hour}}:00 টায় · আসা ইমেল আপনার প্রকল্পে বরাদ্দ হয়।",
  cockpit_email_reports_rooms: "প্রকল্প পরিচালনা করুন",
  cockpit_email_settings: "ইমেল সেটিংস",
  cockpit_email_error_title: "সংযোগ যাচাই করুন",
  cockpit_email_client_title: "ইনবক্স সংযুক্ত",
  cockpit_email_accounts_n: "{{n}}টি অ্যাকাউন্ট সংযুক্ত",
  cockpit_email_last_sync: "সর্বশেষ সিঙ্ক {{when}}",
  cockpit_email_report_at: "দৈনিক রিপোর্ট {{hour}}:00 টায়",
  cockpit_email_open_inbox: "ইনবক্স খুলুন",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "সংযুক্ত ইমেল ঠিকানা",
  email_folder_sent: "পাঠানো আইটেম",
  email_no_subject: "(বিষয় নেই)",
  cockpit_email_detail_loading: "ইমেল লোড হচ্ছে …",
  cockpit_email_detail_failed: "ইমেল লোড করা যায়নি।",
  cockpit_email_detail_empty: "এই ইমেলে কোনো লেখা নেই।",
  cockpit_personal_settings: "ব্যক্তিগত সেটিংস",
  cockpit_companies: "কোম্পানিসমূহ",
  cockpit_title: "ককপিট",
  cockpit_back: "ওভারভিউতে ফিরে যান",
  cockpit_day_overview: "এক নজরে আপনার দিন",
  email_saved_to_project: "ইমেল প্রকল্পে সংরক্ষিত হয়েছে",
  email_classify_need_project: "অনুগ্রহ করে প্রকল্পের নাম লিখুন",
  cockpit_email_deleted: "ইমেল মুছে ফেলা হয়েছে",
  cockpit_email_sent_empty: "এখনও কোনো পাঠানো ইমেল নেই।",
  cockpit_email_incoming_empty: "এখনও কোনো আসা ইমেল নেই।",
  cockpit_email_incoming_title: "ইমেল",
  cockpit_email_incoming_sub: "আসা ও পাঠানো ইমেল আপনার প্রকল্পে বরাদ্দ করুন। বরাদ্দ এখানে পরিবর্তন করতে পারবেন।",
  cockpit_email_incoming_unassigned_n: "{{n}}টি বরাদ্দ হয়নি",
  cockpit_email_folder_inbox: "ইনবক্স",
  cockpit_email_folder_sent: "পাঠানো",
  cockpit_email_open: "ইমেল খুলুন",
  cockpit_email_incoming_suggested: "প্রস্তাবিত: {{room}}",
  cockpit_email_incoming_apply: "প্রয়োগ করুন",
  cockpit_email_incoming_adjust: "বরাদ্দ পরিবর্তন করুন",
  cockpit_email_incoming_saving: "সংরক্ষণ হচ্ছে …",
  cockpit_email_incoming_unassigned: "বরাদ্দ হয়নি",
  cockpit_email_incoming_show_less: "কম দেখান",
  cockpit_email_incoming_show_all: "সব {{n}}টি দেখান",
  cockpit_io_settings: "Kjuup.io সেটিংস",
  cockpit_io_settings_sub: "প্ল্যান ও সিট, কর্মচারী বরাদ্দ, বিলিং ও ইনভয়েস।",
  products_coming_soon: "শীঘ্রই আসছে",
  cockpit_upsell_io_title: "আপনার সাথে ভাবা অফিস",
  cockpit_upsell_io_text: "আপনার ইমেল অ্যাকাউন্ট Kjuup-এর সাথে সংযুক্ত করুন। ইমেল, সংযুক্তি ও বার্তা স্বয়ংক্রিয়ভাবে সংশ্লিষ্ট প্রকল্পে সংরক্ষিত হয় এবং চাইলে আপনার সার্ভারেও রাখা যায়। প্রতিদিন আপনি সব প্রকল্পের সারসংক্ষেপ পান, যেখানে সব বিষয়বস্তুর মূল পয়েন্ট থাকে, এবং আপনার কাজ ক্যালেন্ডার বা to-do অ্যাপের সাথে সিঙ্ক হয়।",
  cockpit_upsell_io_soon_title: "এখনও বুক করা যায় না",
  cockpit_upsell_io_soon_text: "Kjuup.io শীঘ্রই চালু হচ্ছে। এখনই তথ্যের অনুরোধ করুন – Kjuup.io বুক করা সম্ভব হলেই আমরা আপনাকে জানাব।",
  cockpit_upsell_io_planned_price: "পরিকল্পিত মূল্য",
  cockpit_upsell_io_cta_request: "তথ্যের অনুরোধ করুন",
  kjuup_plus_abo_per_year: "/ বছর",
  kjuup_plus_abo_per_month: "/ মাস",
  kjuup_plus_abo_status_active: "সক্রিয়",
  kjuup_plus_abo_status_requested: "বাতিলের অনুরোধ করা হয়েছে",
  kjuup_plus_abo_status_past_due: "পেমেন্ট বকেয়া",
  kjuup_plus_abo_eyebrow: "Kjuup+ · সাবস্ক্রিপশন",
  kjuup_plus_abo_title: "Kjuup+ প্যাকেজ",
  kjuup_plus_abo_seats_free_one: "আরও ১টি সিট বাকি",
  kjuup_plus_abo_billing: "বিলিং",
  kjuup_plus_abo_yearly: "বার্ষিক",
  kjuup_plus_abo_monthly: "মাসিক",
  kjuup_plus_abo_amount: "পরিমাণ",
  kjuup_plus_abo_ends: "শেষ হবে",
  kjuup_plus_abo_renews: "পরবর্তী নবায়ন",
  kjuup_plus_abo_next_invoice: "পরবর্তী ইনভয়েস",
  kjuup_plus_abo_intro: "পরিচিতিমূলক মূল্য",
  kjuup_plus_abo_pending_tier: "পরবর্তী নবায়ন থেকে",
  kjuup_plus_abo_manual: "Kjuup+ আপনার কোম্পানির জন্য ব্যক্তিগত চুক্তির আওতায় সক্রিয় আছে।",
  kjuup_plus_abo_invoices: "ইনভয়েস",
  kjuup_plus_abo_invoice_paid: "পরিশোধিত",
  kjuup_plus_abo_invoice_view: "দেখুন",
  kjuup_plus_abo_invoices_less: "কম দেখান",
  kjuup_plus_abo_member_hint: "বিলিং ও বাতিল আপনার কোম্পানির অ্যাডমিনরা পরিচালনা করেন।",
  kjuup_plus_abo_withdraw: "অনুরোধ প্রত্যাহার করুন",
  kjuup_plus_abo_cancel_note: "কারণ (ঐচ্ছিক)",
  kjuup_plus_abo_cancel_send: "বাতিলের অনুরোধ করুন",
  kjuup_plus_abo_cancel: "সাবস্ক্রিপশন বাতিল করুন",
  cockpit_upsell_plus_f1: "আপনার সব কর্মচারীর যোগাযোগ কার্যক্রম পরিচালনা করুন",
  cockpit_upsell_plus_f2: "কোম্পানির নির্দিষ্ট ব্যবহারকারী গ্রুপকে জানান",
  cockpit_upsell_plus_f3: "অভ্যন্তরীণ গ্রুপ চ্যাট সংরক্ষণ করুন",
  cockpit_upsell_plus_when_yearly: "বার্ষিক পেমেন্টে",
  cockpit_upsell_plus_size_small: "১–৫০ জন কর্মচারী",
  cockpit_upsell_plus_size_large: "৫১–২০০ জন কর্মচারী",
  cockpit_upsell_plus_title: "কোম্পানির জন্য Kjuup+",
  cockpit_upsell_plus_text: "কর্মচারী, লেখার অনুমতি ও কোম্পানির যোগাযোগ এক জায়গায় পরিচালনা করুন। অভ্যন্তরীণ চ্যানেল আপনার দলের মধ্যেই থাকে, বাহ্যিক চ্যানেল আপনাকে প্রকল্প অংশীদারদের সাথে যুক্ত করে, এবং আপনি নির্দিষ্ট গ্রুপে সরাসরি পৌঁছাতে পারেন। Kjuup+ ছাড়াও আপনি কর্মচারী গ্রুপের জন্য Kjuup.io অ্যাক্সেস বুক করতে পারেন। Kjuup+ ও Kjuup.io একসাথে ব্যবহার করা যায়।",
  cockpit_upsell_plus_size: "কোম্পানির আকার",
  cockpit_upsell_plus_billing: "বিলিং",
  cockpit_upsell_plus_per_company: "/ কোম্পানি · মাস, ভ্যাট ছাড়া",
  cockpit_upsell_plus_onboarding: "অনবোর্ডিং/পরিচিতির খরচ কোম্পানির আকারের উপর নির্ভর করে",
  cockpit_upsell_plus_larger: "বড় কোম্পানির জন্য মূল্য অনুরোধে",
  cockpit_upsell_plus_cta: "বাধ্যবাধকতা ছাড়া জিজ্ঞাসা করুন",
  cockpit_kpi_deadlines_tasks: "সময়সীমা ও কাজ",
  cockpit_kpi_appointments: "অ্যাপয়েন্টমেন্ট",
  cockpit_room_admin: "প্রকল্প ও চ্যাট ব্যবস্থাপনা",
  cockpit_room_admin_sub: "সদস্য, মিডিয়া ও চ্যাটসহ কোম্পানির সব প্রকল্প।",
  pro_todo_not_found: "এই কাজটি আর পাওয়া যাচ্ছে না।",
  cockpit_chip_overdue: "বিলম্বিত",
  cockpit_chip_today: "আজ",
  cockpit_calendar_week: "সপ্তাহ {{week}}",
  cockpit_prev_week: "আগের সপ্তাহ",
  cockpit_next_week: "পরের সপ্তাহ",
  cockpit_chip_requested: "অনুরোধ করা হয়েছে",
  cockpit_todo_due: "সময়সীমা {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "{{name}}-এর কাছ থেকে",
  cockpit_todo_since: "{{when}} থেকে",
  cockpit_todo_no_date: "তারিখ নেই",
  cockpit_todo_mark_done: "সম্পন্ন হিসেবে চিহ্নিত করুন",
  cockpit_my_tasks_title: "আমার কাজ",
  cockpit_today_tasks_group: "আজকের কাজ",
  cockpit_assign_none: "কাউকে বরাদ্দ করা হয়নি",
  no_project_found: "কোনো প্রকল্প পাওয়া যায়নি",
  cockpit_row_more_actions: "আরও কাজ",
  needs_date: "তারিখ বরাদ্দ করুন",
  cockpit_assign_proposal: "{{name}} শনাক্ত হয়েছে – বরাদ্দ করবেন?",
  cockpit_assign_proposal_confirm: "বরাদ্দ করুন",
  cockpit_assign_proposal_dismiss: "উপেক্ষা করুন",
  cockpit_priority_date: "তারিখ",
  todo_calendar_add: "ক্যালেন্ডারে যোগ করুন",
  todo_calendar_remove: "ক্যালেন্ডার থেকে সরান",
  cockpit_todo_change_project: "প্রকল্প পরিবর্তন করুন",
  cockpit_todo_set_date: "তারিখ নির্ধারণ করুন",
  pro_todo_done_confirm: "আপনি কি নিশ্চিতভাবে এই কাজটি সম্পন্ন হিসেবে চিহ্নিত করতে চান?",
  cockpit_task_delete_failed: "কাজটি মোছা যায়নি।",
  cockpit_setup_title: "সেটআপ সম্পূর্ণ করুন",
  cockpit_setup_text: "আপনি চ্যাট ব্যবহার করবেন কি না এবং Kjuup.io ইমেল ক্লায়েন্ট হিসেবে কাজ করবে নাকি শুধু প্রকল্প ও দৈনিক রিপোর্টের সাথে, তা ঠিক করুন।",
  cockpit_setup_cta: "এখনই সেট আপ করুন",
  cockpit_group_tasks: "সময়সীমা ও কাজ",
  cockpit_group_appointments: "অ্যাপয়েন্টমেন্ট",
  cockpit_report_no_activity: "গত ২৪ ঘণ্টায় এই প্রকল্পে কোনো নতুন বার্তা বা ইমেল আসেনি।",
  cockpit_report_room_unavailable: "এই প্রকল্পটি উপলব্ধ নয়।",
  cockpit_report_create_failed: "দৈনিক রিপোর্ট তৈরি করা যায়নি।",
  cockpit_report_created: "দৈনিক রিপোর্ট তৈরি হয়েছে",
  addon_enable_confirm: "অ্যাড-অন চালু করবেন?",
  addon_enable: "চালু করুন",
  addon_enabled: "অ্যাড-অন চালু হয়েছে",
  nav_email: "ইমেল",
  nav_my_cockpit: "আমার ককপিট",
  nav_news: "খবর",
  nav_recommend: "সুপারিশ করুন",
  pro_todo_status_done: "সম্পন্ন",
  pro_todo_status_open: "খোলা",
  v2_todo_remove: "সরান",
  pro_todo_search_people: "মানুষ খুঁজুন",
  pro_todo_clear: "মুছুন",
  pro_todo_assigned: "(বরাদ্দ করা হয়েছে)",
  pro_todo_no_people: "কাউকে পাওয়া যায়নি",
  pro_todo_search_rooms: "প্রকল্প খুঁজুন",
  pro_todo_no_rooms_match: "“{{q}}” এর সাথে কোনো প্রকল্প মেলেনি",
  pro_todo_no_rooms: "কোনো প্রকল্প পাওয়া যায়নি",
  pro_todo_activity: "কার্যকলাপ",
  pro_todo_show_less: "কম দেখান",
  pro_todo_show_all: "সব দেখান ({{n}})",
  pro_todo_due: "সময়সীমা",
  pro_todo_room: "প্রকল্প",
  pro_todo_select_room: "প্রকল্প নির্বাচন করুন",
  pro_todo_status: "অবস্থা",
  pro_todo_more: "আরও",
  pro_todo_edit_title: "কাজ সম্পাদনা করুন",
  pro_todo_description: "বিবরণ",
  pro_todo_created_by: "তৈরি করেছেন",
  pro_todo_chat: "চ্যাট",
  navigate_to_source: "সূত্রে যান",
  todo_calendar_connect_title: "কোনো ক্যালেন্ডার সংযুক্ত নেই",
  todo_calendar_connect_body_web: "ToDo যোগ করতে ক্যালেন্ডার সিঙ্ক সেটিংসে একটি ক্যালেন্ডার সংযুক্ত করুন।",
  todo_calendar_connect: "সংযুক্ত করুন",
  todo_calendar_removed: "আপনার ক্যালেন্ডার থেকে সরানো হয়েছে",
  todo_calendar_added_later: "যোগ করা হয়েছে। আপনার ক্যালেন্ডারে পৌঁছানো যায়নি; Kjuup পরে আবার চেষ্টা করবে।",
  todo_calendar_added: "আপনার ক্যালেন্ডারে যোগ করা হয়েছে",
  todo_calendar_no_date: "শুধু তারিখ থাকা ToDo ক্যালেন্ডারে যোগ করা যায়।",
  todo_calendar_failed: "আপনার ক্যালেন্ডার আপডেট করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।",
  todo_calendar_date_title: "এখনও কোনো তারিখ নেই",
  todo_calendar_date_save: "তারিখ নির্ধারণ করে যোগ করুন",
  todo_calendar_date_body_web: "এই বুকমার্ক করা কাজের এখনও কোনো তারিখ নেই। ক্যালেন্ডারে যোগ করতে একটি তারিখ নির্ধারণ করুন।",
  kjuup_io_setup_saved: "সেটআপ সংরক্ষিত হয়েছে",
  kjuup_io_setup_step: "ধাপ",
  kjuup_io_setup_chats_title: "আপনি কি চ্যাট ব্যবহার করতে চান?",
  kjuup_io_setup_email_title: "আপনি কোথায় ইমেল পড়তে চান?",
  kjuup_io_setup_chats_sub: "সহকর্মী ও প্রকল্প অংশীদারদের সাথে চ্যাট ঐচ্ছিক। আপনি যেকোনো সময় ককপিটে সেগুলো দেখাতে বা লুকাতে পারেন।",
  kjuup_io_setup_email_sub: "এটি শুধু ঠিক করে আপনি Kjuup-এ ইমেল ক্লায়েন্ট ব্যবহার করবেন, নাকি Outlook বা অন্য কোনো বর্তমান ইমেল প্রোগ্রামই ব্যবহার করে যাবেন। পরে পরিবর্তন করতে পারেন।",
  kjuup_io_setup_chats_yes: "হ্যাঁ, চ্যাট দেখান",
  kjuup_io_setup_chats_yes_text: "বার্তায় চ্যাট ও ইমেল থাকে। প্রকল্পে সংশ্লিষ্ট সবার জন্য গ্রুপ চ্যাট আছে।",
  kjuup_io_setup_chats_no: "না, চ্যাট ছাড়া কাজ করুন",
  kjuup_io_setup_chats_no_text: "চ্যাট লুকানো থাকে। \"বার্তা\" হয়ে যায় \"ইমেল\"; প্রকল্প, কাজ ও দৈনিক রিপোর্ট থেকে যায়।",
  kjuup_io_setup_email_client: "Kjuup-এ ইমেল ক্লায়েন্ট",
  kjuup_io_setup_email_client_text: "Kjuup-এই সরাসরি ইমেল পড়ুন ও উত্তর দিন।",
  kjuup_io_setup_email_reports: "বর্তমান ইমেল ক্লায়েন্ট",
  kjuup_io_setup_email_reports_text: "Outlook বা অন্য কোনো বর্তমান প্রোগ্রামে পড়া ও উত্তর দেওয়া চালিয়ে যান।",
  kjuup_io_setup_skip: "পরে",
  next: "পরবর্তী",
  kjuup_io_setup_finish: "সেটআপ সম্পূর্ণ করুন",
  today_label: "আজ",
  tomorrow_label: "আগামীকাল",
  cockpit_todo_overdue: "বিলম্বিত",
  cockpit_report_management_fazit: "ব্যবস্থাপনা সারসংক্ষেপ",
  cockpit_todo_appointment: "অ্যাপয়েন্টমেন্ট",
  cockpit_todo_deadline: "সময়সীমা",
  cockpit_todo_deadline_define: "সময়সীমা নির্ধারণ করুন",
  pro_todo_status_acknowledged: "নিশ্চিত করা হয়েছে",
  pro_todo_responsible: "দায়িত্বপ্রাপ্ত",
  pro_todo_notice_confirmed: "চ্যাটে নিশ্চিত করা হয়েছে",
  pro_todo_notice_sent_at: "বার্তা পাঠানো হয়েছে",
  pro_todo_notice_again: "বার্তা আবার পাঠান",
  pro_todo_notice_send: "Kjuup বার্তার মাধ্যমে জানান",
  pro_todo_add_assignee: "যোগ করুন",
  pro_todo_edit: "সম্পাদনা করুন",
  pro_todo_change_room: "প্রকল্প পরিবর্তন করুন",
  pro_todo_due_on: "নির্ধারিত তারিখ",
  pro_todo_edit_due: "নির্ধারিত তারিখ সম্পাদনা করুন",
  pro_todo_no_date: "তারিখ নেই",
  pro_todo_edit_description: "বিবরণ সম্পাদনা করুন",
  pro_todo_no_description: "এখনও কোনো বিবরণ নেই",
  pro_todo_title_label: "শিরোনাম",
  pro_todo_title_placeholder: "শিরোনাম লিখুন...",
  pro_todo_task: "কাজ",
  pro_todo_what: "কী করতে হবে?",
  pro_todo_source_email: "ইমেল",
  pro_todo_sources: "সূত্র",
  previous: "পূর্ববর্তী",
  kjuup_plus_abo_tier_large: "Kjuup+ Large ({max} জন কর্মচারী পর্যন্ত)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small ({max} জন কর্মচারী পর্যন্ত)",
  kjuup_plus_abo_status_ends: "{date} তারিখে শেষ হবে",
  kjuup_plus_abo_seats_over: "{max} জনের বেশি কর্মচারী – Kjuup একটি কাস্টম অফার নিয়ে আপনার সাথে যোগাযোগ করবে।",
  kjuup_plus_abo_seats_next: "আরও কর্মচারী যোগ দিলে প্যাকেজ স্বয়ংক্রিয়ভাবে {next}-এ পরিবর্তিত হবে (আনুপাতিক হারে)।",
  kjuup_plus_abo_seats_used: "{total}টির মধ্যে {used}টি সিট ব্যবহৃত",
  kjuup_plus_abo_seats_free: "আরও {count}টি সিট বাকি",
  kjuup_plus_abo_intro_until: "{date} পর্যন্ত",
  kjuup_plus_abo_invoice_open: "বকেয়া · {date} তারিখে প্রদেয়",
  kjuup_plus_abo_invoices_all: "সব {count}টি দেখান",
  kjuup_plus_abo_requested_hint: "{date} তারিখে বাতিলের অনুরোধ করা হয়েছে। Kjuup মেয়াদের শেষে ({end}) এটি নিশ্চিত করবে।",
  kjuup_plus_abo_cancel_hint: "Kjuup আপনার অনুরোধ পর্যালোচনা করে মেয়াদের শেষে ({end}) বাতিল নিশ্চিত করবে। ততদিন Kjuup+ সক্রিয় থাকবে।",
  kjuup_plus_abo_withdrawn: "বাতিলের অনুরোধ প্রত্যাহার করা হয়েছে",
  kjuup_plus_abo_requested: "বাতিলের অনুরোধ করা হয়েছে",
  cockpit_upsell_plus_intro_hint: "প্রথম {months} মাস, তারপর {price}",
  cockpit_upsell_plus_badge: "{months} মাসের জন্য প্রারম্ভিক মূল্য",
  calendar_syncing: "ক্যালেন্ডার থেকে আপডেট হচ্ছে…",
  calendar_sync_up_to_date: "ক্যালেন্ডার হালনাগাদ আছে",
  calendar_sync_failed: "সিঙ্ক ব্যর্থ হয়েছে",
  delete_multiple_tasks_confirm: "আপনি কি সত্যিই {count}টি ToDo মুছতে চান?",
  todos_deleted_count: "{count}টি ToDo মুছে ফেলা হয়েছে",
  todos_deleted_partial: "{ok}টি ToDo মুছে ফেলা হয়েছে, {fail}টি ব্যর্থ",
  todo_unknown: "অজানা",
  todo_created_from_message: "এই বার্তা থেকে কাজ তৈরি হয়েছে",
  kjuup_io_todo_calendar_trial_ended_note: "ক্যালেন্ডার সিঙ্ক · সাবস্ক্রাইব করুন",
  kjuup_io_todo_calendar_nudge: "এই ToDo আপনার ক্যালেন্ডারে সিঙ্ক করবেন?",
  kjuup_io_todo_calendar_nudge_cta: "Kjuup.io সক্রিয় করুন",
  todo_confirmed: "ToDo নিশ্চিত হয়েছে",
  pro_todo_bulk_delete_title: "{{n}}টি কাজ মুছবেন?",
  pro_todo_previous_none_own: "মেয়াদোত্তীর্ণ কাজগুলো অন্যরা আপনাকে দিয়েছেন এবং শুধু তাঁরাই এগুলো মুছতে পারবেন।",
  pro_todo_previous_none: "কোনো মেয়াদোত্তীর্ণ কাজ নেই",
  pro_todo_previous_title: "{{n}}টি মেয়াদোত্তীর্ণ কাজ মুছবেন?",
  pro_todo_previous_text: "আগের দিনগুলোর আপনার সব খোলা কাজ মুছে ফেলা হবে।",
  pro_todo_previous_skipped: "অন্যদের দেওয়া {{n}}টি কাজ থেকে যাবে।",
  unassign_task_confirm: "আপনি কি এই টাস্ক থেকে নিজের অ্যাসাইনমেন্ট বাতিল করতে চান?",
  unassign_label: "বাতিল",
  pro_todo_delete_title: "কাজ মুছুন",
  pro_todo_today: "আজ",
  pro_todo_yesterday: "গতকাল",
  pro_todo_since_yesterday: "গতকাল থেকে",
  pro_todo_mark_open: "খোলা হিসেবে চিহ্নিত করুন",
  verify_completion: "যাচাই করুন",
  new_label: "নতুন",
  bookmarked_no_mylist: "বুকমার্ক করা কাজ আমার তালিকায় যোগ করা যাবে না",
  delete_only_own: "আপনি শুধু নিজের তৈরি কাজ মুছতে পারবেন",
  todo_clear_all: "সব মুছুন",
  pro_todo_of_completed: "{{total}}টির মধ্যে {{done}}টি সম্পন্ন",
  pro_todo_pick_date: "একটি তারিখ বাছুন",
  pro_todo_show_day: "দিন দেখান",
  todo_adjust_list: "তালিকা সামঞ্জস্য করুন",
  pro_todo_section_upcoming: "আসন্ন",
  pro_todo_section_done: "সম্পন্ন",
  pro_todo_room_empty_today: "এই প্রকল্পে আজ কোনো কাজ নেই",
  pro_todo_room_empty_day: "এই প্রকল্পে এই দিনে কোনো কাজ নেই",
  pro_todo_delete_previous: "সব মুছুন",
  todo_my_list_empty: "আপনার দিন খালি",
  todo_my_list_empty_hint: "কাজ যোগ করতে “তালিকা সামঞ্জস্য করুন”-এ ক্লিক করুন",
  pro_todo_empty_title: "এখানে কিছু নেই",
  pro_todo_empty_hint: "এই ভিউয়ের সাথে কোনো কাজ মেলেনি।",
  pro_todo_selected: "{{n}}টি নির্বাচিত",
  delete_selected_count: "মুছুন ({count})",
  pro_todo_adjust_done: "হয়ে গেছে",
  pro_todo_deleting: "মুছে ফেলা হচ্ছে...",
  pro_todo_reopen: "কাজ আবার খুলুন",
  pro_todo_step_done: "সম্পন্ন",
  move_back_in_progress: "আবার চলমান অবস্থায় ফেরান",
  pro_todo_mark_not_started: "শুরু হয়নি হিসেবে চিহ্নিত করুন",
  back_into_in_progress: "আবার চলমান অবস্থায়",
  pro_todo_mark_in_progress: "চলমান হিসেবে চিহ্নিত করুন",
  unassign_todo: "ToDo অ্যাসাইনমেন্ট বাতিল করুন",
  pro_todo_open_room: "প্রকল্প খুলুন",
  pro_todo_new_task: "নতুন কাজ",
  select_user_back_to_in_progress: "চলমান অবস্থায় ফেরাতে ব্যবহারকারী নির্বাচন করুন",
  cockpit_email_accounts_n_many: "{{n}}টি অ্যাকাউন্ট সংযুক্ত",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup পরিচিতি",
  combined_tab_teams: "Teams পরিচিতি",
  combined_bridge_failed: "Teams কপি তৈরি করা যায়নি।",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup ও Teams পরিচিতি: একটি নতুন গ্রুপ তৈরি হবে যা Microsoft Teams-এও দেখা যাবে।",
  teams_new_chat_title: "নতুন Teams চ্যাট",
  teams_new_chat_topic: "গ্রুপের নাম (ঐচ্ছিক)",
  teams_new_chat_start: "চ্যাট শুরু করুন",
  teams_new_chat_creating: "চ্যাট তৈরি হচ্ছে…",
  teams_new_chat_forbidden: "Microsoft Teams এই চ্যাটের অনুমতি দেয় না (যেমন আপনার প্রতিষ্ঠানের বাইরের কেউ বা আপনার IT-র কোনো নীতি)।",
  teams_new_chat_too_many: "একটি চ্যাটের জন্য অনেক বেশি মানুষ।",
  teams_new_chat_type_hint: "আপনার প্রতিষ্ঠানে খুঁজতে একটি নাম লিখুন।",
  teams_new_chat_directory_forbidden: "আপনার প্রতিষ্ঠান ডিরেক্টরিতে খোঁজার অনুমতি দেয় না। শুধু আপনার Teams চ্যাটের লোকদের দেখানো হচ্ছে।",
  teams_new_chat_account: "অ্যাকাউন্ট",
};
